/* Imports */ /* Imports */ function $f9d9d110dea7aeee$var$toArray(objectOrArray) {
    objectOrArray = objectOrArray || [];
    return Array.isArray(objectOrArray) ? objectOrArray : [
        objectOrArray
    ];
}
function $f9d9d110dea7aeee$var$log(msg) {
    return `[Vaadin.Router] ${msg}`;
}
function $f9d9d110dea7aeee$var$logValue(value) {
    if (typeof value !== "object") return String(value);
    const stringType = Object.prototype.toString.call(value).match(/ (.*)\]$/)[1];
    if (stringType === "Object" || stringType === "Array") return `${stringType} ${JSON.stringify(value)}`;
    else return stringType;
}
const $f9d9d110dea7aeee$var$MODULE = "module";
const $f9d9d110dea7aeee$var$NOMODULE = "nomodule";
const $f9d9d110dea7aeee$var$bundleKeys = [
    $f9d9d110dea7aeee$var$MODULE,
    $f9d9d110dea7aeee$var$NOMODULE
];
function $f9d9d110dea7aeee$var$ensureBundle(src) {
    if (!src.match(/.+\.[m]?js$/)) throw new Error($f9d9d110dea7aeee$var$log(`Unsupported type for bundle "${src}": .js or .mjs expected.`));
}
function $f9d9d110dea7aeee$var$ensureRoute(route) {
    if (!route || !$f9d9d110dea7aeee$var$isString(route.path)) throw new Error($f9d9d110dea7aeee$var$log(`Expected route config to be an object with a "path" string property, or an array of such objects`));
    const bundle = route.bundle;
    const stringKeys = [
        "component",
        "redirect",
        "bundle"
    ];
    if (!$f9d9d110dea7aeee$var$isFunction(route.action) && !Array.isArray(route.children) && !$f9d9d110dea7aeee$var$isFunction(route.children) && !$f9d9d110dea7aeee$var$isObject(bundle) && !stringKeys.some((key)=>$f9d9d110dea7aeee$var$isString(route[key]))) throw new Error($f9d9d110dea7aeee$var$log(`Expected route config "${route.path}" to include either "${stringKeys.join('", "')}" ` + `or "action" function but none found.`));
    if (bundle) {
        if ($f9d9d110dea7aeee$var$isString(bundle)) $f9d9d110dea7aeee$var$ensureBundle(bundle);
        else if (!$f9d9d110dea7aeee$var$bundleKeys.some((key)=>key in bundle)) throw new Error($f9d9d110dea7aeee$var$log('Expected route bundle to include either "' + $f9d9d110dea7aeee$var$NOMODULE + '" or "' + $f9d9d110dea7aeee$var$MODULE + '" keys, or both'));
        else $f9d9d110dea7aeee$var$bundleKeys.forEach((key)=>key in bundle && $f9d9d110dea7aeee$var$ensureBundle(bundle[key]));
    }
    if (route.redirect) [
        "bundle",
        "component"
    ].forEach((overriddenProp)=>{
        if (overriddenProp in route) console.warn($f9d9d110dea7aeee$var$log(`Route config "${route.path}" has both "redirect" and "${overriddenProp}" properties, ` + `and "redirect" will always override the latter. Did you mean to only use "${overriddenProp}"?`));
    });
}
function $f9d9d110dea7aeee$var$ensureRoutes(routes) {
    $f9d9d110dea7aeee$var$toArray(routes).forEach((route)=>$f9d9d110dea7aeee$var$ensureRoute(route));
}
function $f9d9d110dea7aeee$var$loadScript(src, key) {
    let script = document.head.querySelector('script[src="' + src + '"][async]');
    if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", src);
        if (key === $f9d9d110dea7aeee$var$MODULE) script.setAttribute("type", $f9d9d110dea7aeee$var$MODULE);
        else if (key === $f9d9d110dea7aeee$var$NOMODULE) script.setAttribute($f9d9d110dea7aeee$var$NOMODULE, "");
        script.async = true;
    }
    return new Promise((resolve, reject)=>{
        script.onreadystatechange = script.onload = (e)=>{
            script.__dynamicImportLoaded = true;
            resolve(e);
        };
        script.onerror = (e)=>{
            if (script.parentNode) script.parentNode.removeChild(script);
            reject(e);
        };
        if (script.parentNode === null) document.head.appendChild(script);
        else if (script.__dynamicImportLoaded) resolve();
    });
}
function $f9d9d110dea7aeee$var$loadBundle(bundle) {
    if ($f9d9d110dea7aeee$var$isString(bundle)) return $f9d9d110dea7aeee$var$loadScript(bundle);
    else return Promise.race($f9d9d110dea7aeee$var$bundleKeys.filter((key)=>key in bundle).map((key)=>$f9d9d110dea7aeee$var$loadScript(bundle[key], key)));
}
function $f9d9d110dea7aeee$var$fireRouterEvent(type, detail) {
    return !window.dispatchEvent(new CustomEvent(`vaadin-router-${type}`, {
        cancelable: type === "go",
        detail: detail
    }));
}
function $f9d9d110dea7aeee$var$isObject(o) {
    // guard against null passing the typeof check
    return typeof o === "object" && !!o;
}
function $f9d9d110dea7aeee$var$isFunction(f) {
    return typeof f === "function";
}
function $f9d9d110dea7aeee$var$isString(s) {
    return typeof s === "string";
}
function $f9d9d110dea7aeee$var$getNotFoundError(context) {
    const error = new Error($f9d9d110dea7aeee$var$log(`Page not found (${context.pathname})`));
    error.context = context;
    error.code = 404;
    return error;
}
const $f9d9d110dea7aeee$var$notFoundResult = new class NotFoundResult {
}();
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ function $f9d9d110dea7aeee$var$getAnchorOrigin(anchor) {
    // IE11: on HTTP and HTTPS the default port is not included into
    // window.location.origin, so won't include it here either.
    const port = anchor.port;
    const protocol = anchor.protocol;
    const defaultHttp = protocol === "http:" && port === "80";
    const defaultHttps = protocol === "https:" && port === "443";
    const host = defaultHttp || defaultHttps ? anchor.hostname // does not include the port number (e.g. www.example.org)
     : anchor.host; // does include the port number (e.g. www.example.org:80)
    return `${protocol}//${host}`;
}
// The list of checks is not complete:
//  - SVG support is missing
//  - the 'rel' attribute is not considered
function $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler(event) {
    // ignore the click if the default action is prevented
    if (event.defaultPrevented) return;
    // ignore the click if not with the primary mouse button
    if (event.button !== 0) return;
    // ignore the click if a modifier key is pressed
    if (event.shiftKey || event.ctrlKey || event.altKey || event.metaKey) return;
    // find the <a> element that the click is at (or within)
    let anchor = event.target;
    const path = event.composedPath ? event.composedPath() : event.path || [];
    // FIXME(web-padawan): `Symbol.iterator` used by webcomponentsjs is broken for arrays
    // example to check: `for...of` loop here throws the "Not yet implemented" error
    for(let i = 0; i < path.length; i++){
        const target = path[i];
        if (target.nodeName && target.nodeName.toLowerCase() === "a") {
            anchor = target;
            break;
        }
    }
    while(anchor && anchor.nodeName.toLowerCase() !== "a")anchor = anchor.parentNode;
    // ignore the click if not at an <a> element
    if (!anchor || anchor.nodeName.toLowerCase() !== "a") return;
    // ignore the click if the <a> element has a non-default target
    if (anchor.target && anchor.target.toLowerCase() !== "_self") return;
    // ignore the click if the <a> element has the 'download' attribute
    if (anchor.hasAttribute("download")) return;
    // ignore the click if the <a> element has the 'router-ignore' attribute
    if (anchor.hasAttribute("router-ignore")) return;
    // ignore the click if the target URL is a fragment on the current page
    if (anchor.pathname === window.location.pathname && anchor.hash !== "") return;
    // ignore the click if the target is external to the app
    // In IE11 HTMLAnchorElement does not have the `origin` property
    const origin = anchor.origin || $f9d9d110dea7aeee$var$getAnchorOrigin(anchor);
    if (origin !== window.location.origin) return;
    // if none of the above, convert the click into a navigation event
    const { pathname: pathname, search: search, hash: hash } = anchor;
    if ($f9d9d110dea7aeee$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    })) {
        event.preventDefault();
        // for a click event, the scroll is reset to the top position.
        if (event && event.type === "click") window.scrollTo(0, 0);
    }
}
/**
 * A navigation trigger for Vaadin Router that translated clicks on `<a>` links
 * into Vaadin Router navigation events.
 *
 * Only regular clicks on in-app links are translated (primary mouse button, no
 * modifier keys, the target href is within the app's URL space).
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $f9d9d110dea7aeee$var$CLICK = {
    activate () {
        window.document.addEventListener("click", $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler);
    },
    inactivate () {
        window.document.removeEventListener("click", $f9d9d110dea7aeee$var$vaadinRouterGlobalClickHandler);
    }
};
// PopStateEvent constructor shim
const $f9d9d110dea7aeee$var$isIE = /Trident/.test(navigator.userAgent);
/* istanbul ignore next: coverage is calculated in Chrome, this code is for IE */ if ($f9d9d110dea7aeee$var$isIE && !$f9d9d110dea7aeee$var$isFunction(window.PopStateEvent)) {
    window.PopStateEvent = function(inType, params) {
        params = params || {};
        var e = document.createEvent("Event");
        e.initEvent(inType, Boolean(params.bubbles), Boolean(params.cancelable));
        e.state = params.state || null;
        return e;
    };
    window.PopStateEvent.prototype = window.Event.prototype;
}
function $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler(event) {
    if (event.state === "vaadin-router-ignore") return;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    $f9d9d110dea7aeee$var$fireRouterEvent("go", {
        pathname: pathname,
        search: search,
        hash: hash
    });
}
/**
 * A navigation trigger for Vaadin Router that translates popstate events into
 * Vaadin Router navigation events.
 *
 * @memberOf Router.NavigationTrigger
 * @type {NavigationTrigger}
 */ const $f9d9d110dea7aeee$var$POPSTATE = {
    activate () {
        window.addEventListener("popstate", $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler);
    },
    inactivate () {
        window.removeEventListener("popstate", $f9d9d110dea7aeee$var$vaadinRouterGlobalPopstateHandler);
    }
};
/**
 * Expose `pathToRegexp`.
 */ var $f9d9d110dea7aeee$var$pathToRegexp_1 = $f9d9d110dea7aeee$var$pathToRegexp$1;
var $f9d9d110dea7aeee$var$parse_1 = $f9d9d110dea7aeee$var$parse;
var $f9d9d110dea7aeee$var$compile_1 = $f9d9d110dea7aeee$var$compile;
var $f9d9d110dea7aeee$var$tokensToFunction_1 = $f9d9d110dea7aeee$var$tokensToFunction;
var $f9d9d110dea7aeee$var$tokensToRegExp_1 = $f9d9d110dea7aeee$var$tokensToRegExp;
/**
 * Default configs.
 */ var $f9d9d110dea7aeee$var$DEFAULT_DELIMITER = "/";
var $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS = "./";
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $f9d9d110dea7aeee$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $f9d9d110dea7aeee$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || $f9d9d110dea7aeee$var$DEFAULT_DELIMITER;
    var delimiters = options && options.delimiters || $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS;
    var pathEscaped = false;
    var res;
    while((res = $f9d9d110dea7aeee$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = "";
        var next = str[index];
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            if (delimiters.indexOf(path[k]) > -1) {
                prev = path[k];
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
            pathEscaped = false;
        }
        var partial = prev !== "" && next !== undefined && next !== prev;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = prev || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            pattern: pattern ? $f9d9d110dea7aeee$var$escapeGroup(pattern) : "[^" + $f9d9d110dea7aeee$var$escapeString(delimiter) + "]+?"
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $f9d9d110dea7aeee$var$compile(str, options) {
    return $f9d9d110dea7aeee$var$tokensToFunction($f9d9d110dea7aeee$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $f9d9d110dea7aeee$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$");
    return function(data, options) {
        var path = "";
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) {
                // Prepend partial segment prefixes.
                if (token.partial) path += token.prefix;
                continue;
            }
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? "an array" : "a string"));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $f9d9d110dea7aeee$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $f9d9d110dea7aeee$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $f9d9d110dea7aeee$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($f9d9d110dea7aeee$var$pathToRegexp$1(path[i], keys, options).source);
    return new RegExp("(?:" + parts.join("|") + ")", $f9d9d110dea7aeee$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$stringToRegexp(path, keys, options) {
    return $f9d9d110dea7aeee$var$tokensToRegExp($f9d9d110dea7aeee$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = $f9d9d110dea7aeee$var$escapeString(options.delimiter || $f9d9d110dea7aeee$var$DEFAULT_DELIMITER);
    var delimiters = options.delimiters || $f9d9d110dea7aeee$var$DEFAULT_DELIMITERS;
    var endsWith = [].concat(options.endsWith || []).map($f9d9d110dea7aeee$var$escapeString).concat("$").join("|");
    var route = start ? "^" : "";
    var isEndDelimited = tokens.length === 0;
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") {
            route += $f9d9d110dea7aeee$var$escapeString(token);
            isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1;
        } else {
            var capture = token.repeat ? "(?:" + token.pattern + ")(?:" + $f9d9d110dea7aeee$var$escapeString(token.delimiter) + "(?:" + token.pattern + "))*" : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (token.partial) route += $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + ")?";
                else route += "(?:" + $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + "))?";
            } else route += $f9d9d110dea7aeee$var$escapeString(token.prefix) + "(" + capture + ")";
        }
    }
    if (end) {
        if (!strict) route += "(?:" + delimiter + ")?";
        route += endsWith === "$" ? "$" : "(?=" + endsWith + ")";
    } else {
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, $f9d9d110dea7aeee$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $f9d9d110dea7aeee$var$pathToRegexp$1(path, keys, options) {
    if (path instanceof RegExp) return $f9d9d110dea7aeee$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $f9d9d110dea7aeee$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $f9d9d110dea7aeee$var$stringToRegexp(/** @type {string} */ path, keys, options);
}
$f9d9d110dea7aeee$var$pathToRegexp_1.parse = $f9d9d110dea7aeee$var$parse_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.compile = $f9d9d110dea7aeee$var$compile_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.tokensToFunction = $f9d9d110dea7aeee$var$tokensToFunction_1;
$f9d9d110dea7aeee$var$pathToRegexp_1.tokensToRegExp = $f9d9d110dea7aeee$var$tokensToRegExp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { hasOwnProperty: $f9d9d110dea7aeee$var$hasOwnProperty } = Object.prototype;
const $f9d9d110dea7aeee$var$cache$1 = new Map();
// see https://github.com/pillarjs/path-to-regexp/issues/148
$f9d9d110dea7aeee$var$cache$1.set("|false", {
    keys: [],
    pattern: /(?:)/
});
function $f9d9d110dea7aeee$var$decodeParam(val) {
    try {
        return decodeURIComponent(val);
    } catch (err) {
        return val;
    }
}
function $f9d9d110dea7aeee$var$matchPath(routepath, path, exact, parentKeys, parentParams) {
    exact = !!exact;
    const cacheKey = `${routepath}|${exact}`;
    let regexp = $f9d9d110dea7aeee$var$cache$1.get(cacheKey);
    if (!regexp) {
        const keys = [];
        regexp = {
            keys: keys,
            pattern: $f9d9d110dea7aeee$var$pathToRegexp_1(routepath, keys, {
                end: exact,
                strict: routepath === ""
            })
        };
        $f9d9d110dea7aeee$var$cache$1.set(cacheKey, regexp);
    }
    const m = regexp.pattern.exec(path);
    if (!m) return null;
    const params = Object.assign({}, parentParams);
    for(let i = 1; i < m.length; i++){
        const key = regexp.keys[i - 1];
        const prop = key.name;
        const value = m[i];
        if (value !== undefined || !$f9d9d110dea7aeee$var$hasOwnProperty.call(params, prop)) {
            if (key.repeat) params[prop] = value ? value.split(key.delimiter).map($f9d9d110dea7aeee$var$decodeParam) : [];
            else params[prop] = value ? $f9d9d110dea7aeee$var$decodeParam(value) : value;
        }
    }
    return {
        path: m[0],
        keys: (parentKeys || []).concat(regexp.keys),
        params: params
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ /**
 * Traverses the routes tree and matches its nodes to the given pathname from
 * the root down to the leaves. Each match consumes a part of the pathname and
 * the matching process continues for as long as there is a matching child
 * route for the remaining part of the pathname.
 *
 * The returned value is a lazily evaluated iterator.
 *
 * The leading "/" in a route path matters only for the root of the routes
 * tree (or if all parent routes are ""). In all other cases a leading "/" in
 * a child route path has no significance.
 *
 * The trailing "/" in a _route path_ matters only for the leaves of the
 * routes tree. A leaf route with a trailing "/" matches only a pathname that
 * also has a trailing "/".
 *
 * The trailing "/" in a route path does not affect matching of child routes
 * in any way.
 *
 * The trailing "/" in a _pathname_ generally does not matter (except for
 * the case of leaf nodes described above).
 *
 * The "" and "/" routes have special treatment:
 *  1. as a single route
 *     the "" and "/" routes match only the "" and "/" pathnames respectively
 *  2. as a parent in the routes tree
 *     the "" route matches any pathname without consuming any part of it
 *     the "/" route matches any absolute pathname consuming its leading "/"
 *  3. as a leaf in the routes tree
 *     the "" and "/" routes match only if the entire pathname is consumed by
 *         the parent routes chain. In this case "" and "/" are equivalent.
 *  4. several directly nested "" or "/" routes
 *     - directly nested "" or "/" routes are 'squashed' (i.e. nesting two
 *       "/" routes does not require a double "/" in the pathname to match)
 *     - if there are only "" in the parent routes chain, no part of the
 *       pathname is consumed, and the leading "/" in the child routes' paths
 *       remains significant
 *
 * Side effect:
 *   - the routes tree { path: '' } matches only the '' pathname
 *   - the routes tree { path: '', children: [ { path: '' } ] } matches any
 *     pathname (for the tree root)
 *
 * Prefix matching can be enabled also by `children: true`.
 */ function $f9d9d110dea7aeee$var$matchRoute(route, pathname, ignoreLeadingSlash, parentKeys, parentParams) {
    let match;
    let childMatches;
    let childIndex = 0;
    let routepath = route.path || "";
    if (routepath.charAt(0) === "/") {
        if (ignoreLeadingSlash) routepath = routepath.substr(1);
        ignoreLeadingSlash = true;
    }
    return {
        next (routeToSkip) {
            if (route === routeToSkip) return {
                done: true
            };
            const children = route.__children = route.__children || route.children;
            if (!match) {
                match = $f9d9d110dea7aeee$var$matchPath(routepath, pathname, !children, parentKeys, parentParams);
                if (match) return {
                    done: false,
                    value: {
                        route: route,
                        keys: match.keys,
                        params: match.params,
                        path: match.path
                    }
                };
            }
            if (match && children) while(childIndex < children.length){
                if (!childMatches) {
                    const childRoute = children[childIndex];
                    childRoute.parent = route;
                    let matchedLength = match.path.length;
                    if (matchedLength > 0 && pathname.charAt(matchedLength) === "/") matchedLength += 1;
                    childMatches = $f9d9d110dea7aeee$var$matchRoute(childRoute, pathname.substr(matchedLength), ignoreLeadingSlash, match.keys, match.params);
                }
                const childMatch = childMatches.next(routeToSkip);
                if (!childMatch.done) return {
                    done: false,
                    value: childMatch.value
                };
                childMatches = null;
                childIndex++;
            }
            return {
                done: true
            };
        }
    };
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $f9d9d110dea7aeee$var$resolveRoute(context) {
    if ($f9d9d110dea7aeee$var$isFunction(context.route.action)) return context.route.action(context);
    return undefined;
}
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ function $f9d9d110dea7aeee$var$isChildRoute(parentRoute, childRoute) {
    let route = childRoute;
    while(route){
        route = route.parent;
        if (route === parentRoute) return true;
    }
    return false;
}
function $f9d9d110dea7aeee$var$generateErrorMessage(currentContext) {
    let errorMessage = `Path '${currentContext.pathname}' is not properly resolved due to an error.`;
    const routePath = (currentContext.route || {}).path;
    if (routePath) errorMessage += ` Resolution had failed on route: '${routePath}'`;
    return errorMessage;
}
function $f9d9d110dea7aeee$var$updateChainForRoute(context, match) {
    const { route: route, path: path } = match;
    if (route && !route.__synthetic) {
        const item = {
            path: path,
            route: route
        };
        if (!context.chain) context.chain = [];
        else // Discard old items
        if (route.parent) {
            let i = context.chain.length;
            while(i-- && context.chain[i].route && context.chain[i].route !== route.parent)context.chain.pop();
        }
        context.chain.push(item);
    }
}
/**
 */ class $f9d9d110dea7aeee$export$8b4c839865b08288 {
    constructor(routes, options = {}){
        if (Object(routes) !== routes) throw new TypeError("Invalid routes");
        this.baseUrl = options.baseUrl || "";
        this.errorHandler = options.errorHandler;
        this.resolveRoute = options.resolveRoute || $f9d9d110dea7aeee$var$resolveRoute;
        this.context = Object.assign({
            resolver: this
        }, options.context);
        this.root = Array.isArray(routes) ? {
            path: "",
            __children: routes,
            parent: null,
            __synthetic: true
        } : routes;
        this.root.parent = null;
    }
    /**
   * Returns the current list of routes (as a shallow copy). Adding / removing
   * routes to / from the returned array does not affect the routing config,
   * but modifying the route objects does.
   *
   * @return {!Array<!Router.Route>}
   */ getRoutes() {
        return [
            ...this.root.__children
        ];
    }
    /**
   * Sets the routing config (replacing the existing one).
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   */ setRoutes(routes) {
        $f9d9d110dea7aeee$var$ensureRoutes(routes);
        const newRoutes = [
            ...$f9d9d110dea7aeee$var$toArray(routes)
        ];
        this.root.__children = newRoutes;
    }
    /**
   * Appends one or several routes to the routing config and returns the
   * effective routing config after the operation.
   *
   * @param {!Array<!Router.Route>|!Router.Route} routes a single route or an array of those
   *    (the array is shallow copied)
   * @return {!Array<!Router.Route>}
   * @protected
   */ addRoutes(routes) {
        $f9d9d110dea7aeee$var$ensureRoutes(routes);
        this.root.__children.push(...$f9d9d110dea7aeee$var$toArray(routes));
        return this.getRoutes();
    }
    /**
   * Removes all existing routes from the routing config.
   */ removeRoutes() {
        this.setRoutes([]);
    }
    /**
   * Asynchronously resolves the given pathname, i.e. finds all routes matching
   * the pathname and tries resolving them one after another in the order they
   * are listed in the routes config until the first non-null result.
   *
   * Returns a promise that is fulfilled with the return value of an object that consists of the first
   * route handler result that returns something other than `null` or `undefined` and context used to get this result.
   *
   * If no route handlers return a non-null result, or if no route matches the
   * given pathname the returned promise is rejected with a 'page not found'
   * `Error`.
   *
   * @param {!string|!{pathname: !string}} pathnameOrContext the pathname to
   *    resolve or a context object with a `pathname` property and other
   *    properties to pass to the route resolver functions.
   * @return {!Promise<any>}
   */ resolve(pathnameOrContext) {
        const context = Object.assign({}, this.context, $f9d9d110dea7aeee$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext);
        const match = $f9d9d110dea7aeee$var$matchRoute(this.root, this.__normalizePathname(context.pathname), this.baseUrl);
        const resolve = this.resolveRoute;
        let matches = null;
        let nextMatches = null;
        let currentContext = context;
        function next(resume, parent = matches.value.route, prevResult) {
            const routeToSkip = prevResult === null && matches.value.route;
            matches = nextMatches || match.next(routeToSkip);
            nextMatches = null;
            if (!resume) {
                if (matches.done || !$f9d9d110dea7aeee$var$isChildRoute(parent, matches.value.route)) {
                    nextMatches = matches;
                    return Promise.resolve($f9d9d110dea7aeee$var$notFoundResult);
                }
            }
            if (matches.done) return Promise.reject($f9d9d110dea7aeee$var$getNotFoundError(context));
            currentContext = Object.assign(currentContext ? {
                chain: currentContext.chain ? currentContext.chain.slice(0) : []
            } : {}, context, matches.value);
            $f9d9d110dea7aeee$var$updateChainForRoute(currentContext, matches.value);
            return Promise.resolve(resolve(currentContext)).then((resolution)=>{
                if (resolution !== null && resolution !== undefined && resolution !== $f9d9d110dea7aeee$var$notFoundResult) {
                    currentContext.result = resolution.result || resolution;
                    return currentContext;
                }
                return next(resume, parent, resolution);
            });
        }
        context.next = next;
        return Promise.resolve().then(()=>next(true, this.root)).catch((error)=>{
            const errorMessage = $f9d9d110dea7aeee$var$generateErrorMessage(currentContext);
            if (!error) error = new Error(errorMessage);
            else console.warn(errorMessage);
            error.context = error.context || currentContext;
            // DOMException has its own code which is read-only
            if (!(error instanceof DOMException)) error.code = error.code || 500;
            if (this.errorHandler) {
                currentContext.result = this.errorHandler(error);
                return currentContext;
            }
            throw error;
        });
    }
    /**
   * URL constructor polyfill hook. Creates and returns an URL instance.
   */ static __createUrl(url, base) {
        return new URL(url, base);
    }
    /**
   * If the baseUrl property is set, transforms the baseUrl and returns the full
   * actual `base` string for using in the `new URL(path, base);` and for
   * prepernding the paths with. The returned base ends with a trailing slash.
   *
   * Otherwise, returns empty string.
   */ get __effectiveBaseUrl() {
        return this.baseUrl ? this.constructor.__createUrl(this.baseUrl, document.baseURI || document.URL).href.replace(/[^\/]*$/, "") : "";
    }
    /**
   * If the baseUrl is set, matches the pathname with the router’s baseUrl,
   * and returns the local pathname with the baseUrl stripped out.
   *
   * If the pathname does not match the baseUrl, returns undefined.
   *
   * If the `baseUrl` is not set, returns the unmodified pathname argument.
   */ __normalizePathname(pathname) {
        if (!this.baseUrl) // No base URL, no need to transform the pathname.
        return pathname;
        const base = this.__effectiveBaseUrl;
        const normalizedUrl = this.constructor.__createUrl(pathname, base).href;
        if (normalizedUrl.slice(0, base.length) === base) return normalizedUrl.slice(base.length);
    }
}
$f9d9d110dea7aeee$export$8b4c839865b08288.pathToRegexp = $f9d9d110dea7aeee$var$pathToRegexp_1;
/**
 * Universal Router (https://www.kriasoft.com/universal-router/)
 *
 * Copyright (c) 2015-present Kriasoft.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */ const { pathToRegexp: $f9d9d110dea7aeee$var$pathToRegexp } = $f9d9d110dea7aeee$export$8b4c839865b08288;
const $f9d9d110dea7aeee$var$cache = new Map();
function $f9d9d110dea7aeee$var$cacheRoutes(routesByName, route, routes) {
    const name = route.name || route.component;
    if (name) {
        if (routesByName.has(name)) routesByName.get(name).push(route);
        else routesByName.set(name, [
            route
        ]);
    }
    if (Array.isArray(routes)) for(let i = 0; i < routes.length; i++){
        const childRoute = routes[i];
        childRoute.parent = route;
        $f9d9d110dea7aeee$var$cacheRoutes(routesByName, childRoute, childRoute.__children || childRoute.children);
    }
}
function $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName) {
    const routes = routesByName.get(routeName);
    if (routes && routes.length > 1) throw new Error(`Duplicate route with name "${routeName}".` + ` Try seting unique 'name' route properties.`);
    return routes && routes[0];
}
function $f9d9d110dea7aeee$var$getRoutePath(route) {
    let path = route.path;
    path = Array.isArray(path) ? path[0] : path;
    return path !== undefined ? path : "";
}
function $f9d9d110dea7aeee$var$generateUrls(router, options = {}) {
    if (!(router instanceof $f9d9d110dea7aeee$export$8b4c839865b08288)) throw new TypeError("An instance of Resolver is expected");
    const routesByName = new Map();
    return (routeName, params)=>{
        let route = $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName);
        if (!route) {
            routesByName.clear(); // clear cache
            $f9d9d110dea7aeee$var$cacheRoutes(routesByName, router.root, router.root.__children);
            route = $f9d9d110dea7aeee$var$getRouteByName(routesByName, routeName);
            if (!route) throw new Error(`Route "${routeName}" not found`);
        }
        let regexp = $f9d9d110dea7aeee$var$cache.get(route.fullPath);
        if (!regexp) {
            let fullPath = $f9d9d110dea7aeee$var$getRoutePath(route);
            let rt = route.parent;
            while(rt){
                const path = $f9d9d110dea7aeee$var$getRoutePath(rt);
                if (path) fullPath = path.replace(/\/$/, "") + "/" + fullPath.replace(/^\//, "");
                rt = rt.parent;
            }
            const tokens = $f9d9d110dea7aeee$var$pathToRegexp.parse(fullPath);
            const toPath = $f9d9d110dea7aeee$var$pathToRegexp.tokensToFunction(tokens);
            const keys = Object.create(null);
            for(let i = 0; i < tokens.length; i++)if (!$f9d9d110dea7aeee$var$isString(tokens[i])) keys[tokens[i].name] = true;
            regexp = {
                toPath: toPath,
                keys: keys
            };
            $f9d9d110dea7aeee$var$cache.set(fullPath, regexp);
            route.fullPath = fullPath;
        }
        let url = regexp.toPath(params, options) || "/";
        if (options.stringifyQueryParams && params) {
            const queryParams = {};
            const keys = Object.keys(params);
            for(let i = 0; i < keys.length; i++){
                const key = keys[i];
                if (!regexp.keys[key]) queryParams[key] = params[key];
            }
            const query = options.stringifyQueryParams(queryParams);
            if (query) url += query.charAt(0) === "?" ? query : `?${query}`;
        }
        return url;
    };
}
/**
 * @typedef NavigationTrigger
 * @type {object}
 * @property {function()} activate
 * @property {function()} inactivate
 */ /** @type {Array<NavigationTrigger>} */ let $f9d9d110dea7aeee$var$triggers = [];
function $f9d9d110dea7aeee$var$setNavigationTriggers(newTriggers) {
    $f9d9d110dea7aeee$var$triggers.forEach((trigger)=>trigger.inactivate());
    newTriggers.forEach((trigger)=>trigger.activate());
    $f9d9d110dea7aeee$var$triggers = newTriggers;
}
const $f9d9d110dea7aeee$var$willAnimate = (elem)=>{
    const name = getComputedStyle(elem).getPropertyValue("animation-name");
    return name && name !== "none";
};
const $f9d9d110dea7aeee$var$waitForAnimation = (elem, cb)=>{
    const listener = ()=>{
        elem.removeEventListener("animationend", listener);
        cb();
    };
    elem.addEventListener("animationend", listener);
};
function $f9d9d110dea7aeee$var$animate(elem, className) {
    elem.classList.add(className);
    return new Promise((resolve)=>{
        if ($f9d9d110dea7aeee$var$willAnimate(elem)) {
            const rect = elem.getBoundingClientRect();
            const size = `height: ${rect.bottom - rect.top}px; width: ${rect.right - rect.left}px`;
            elem.setAttribute("style", `position: absolute; ${size}`);
            $f9d9d110dea7aeee$var$waitForAnimation(elem, ()=>{
                elem.classList.remove(className);
                elem.removeAttribute("style");
                resolve();
            });
        } else {
            elem.classList.remove(className);
            resolve();
        }
    });
}
const $f9d9d110dea7aeee$var$MAX_REDIRECT_COUNT = 256;
function $f9d9d110dea7aeee$var$isResultNotEmpty(result) {
    return result !== null && result !== undefined;
}
function $f9d9d110dea7aeee$var$copyContextWithoutNext(context) {
    const copy = Object.assign({}, context);
    delete copy.next;
    return copy;
}
function $f9d9d110dea7aeee$var$createLocation({ pathname: pathname = "", search: search = "", hash: hash = "", chain: chain = [], params: params = {}, redirectFrom: redirectFrom, resolver: resolver }, route) {
    const routes = chain.map((item)=>item.route);
    return {
        baseUrl: resolver && resolver.baseUrl || "",
        pathname: pathname,
        search: search,
        hash: hash,
        routes: routes,
        route: route || routes.length && routes[routes.length - 1] || null,
        params: params,
        redirectFrom: redirectFrom,
        getUrl: (userParams = {})=>$f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$export$55185c17a0fcbe46.pathToRegexp.compile($f9d9d110dea7aeee$var$getMatchedPath(routes))(Object.assign({}, params, userParams)), resolver)
    };
}
function $f9d9d110dea7aeee$var$createRedirect(context, pathname) {
    const params = Object.assign({}, context.params);
    return {
        redirect: {
            pathname: pathname,
            from: context.pathname,
            params: params
        }
    };
}
function $f9d9d110dea7aeee$var$renderElement(context, element) {
    element.location = $f9d9d110dea7aeee$var$createLocation(context);
    const index = context.chain.map((item)=>item.route).indexOf(context.route);
    context.chain[index].element = element;
    return element;
}
function $f9d9d110dea7aeee$var$runCallbackIfPossible(callback, args, thisArg) {
    if ($f9d9d110dea7aeee$var$isFunction(callback)) return callback.apply(thisArg, args);
}
function $f9d9d110dea7aeee$var$amend(amendmentFunction, args, element) {
    return (amendmentResult)=>{
        if (amendmentResult && (amendmentResult.cancel || amendmentResult.redirect)) return amendmentResult;
        if (element) return $f9d9d110dea7aeee$var$runCallbackIfPossible(element[amendmentFunction], args, element);
    };
}
function $f9d9d110dea7aeee$var$processNewChildren(newChildren, route) {
    if (!Array.isArray(newChildren) && !$f9d9d110dea7aeee$var$isObject(newChildren)) throw new Error($f9d9d110dea7aeee$var$log(`Incorrect "children" value for the route ${route.path}: expected array or object, but got ${newChildren}`));
    route.__children = [];
    const childRoutes = $f9d9d110dea7aeee$var$toArray(newChildren);
    for(let i = 0; i < childRoutes.length; i++){
        $f9d9d110dea7aeee$var$ensureRoute(childRoutes[i]);
        route.__children.push(childRoutes[i]);
    }
}
function $f9d9d110dea7aeee$var$removeDomNodes(nodes) {
    if (nodes && nodes.length) {
        const parent = nodes[0].parentNode;
        for(let i = 0; i < nodes.length; i++)parent.removeChild(nodes[i]);
    }
}
function $f9d9d110dea7aeee$var$getPathnameForRouter(pathname, router) {
    const base = router.__effectiveBaseUrl;
    return base ? router.constructor.__createUrl(pathname.replace(/^\//, ""), base).pathname : pathname;
}
function $f9d9d110dea7aeee$var$getMatchedPath(chain) {
    return chain.map((item)=>item.path).reduce((a, b)=>{
        if (b.length) return a.replace(/\/$/, "") + "/" + b.replace(/^\//, "");
        return a;
    }, "");
}
/**
 * A simple client-side router for single-page applications. It uses
 * express-style middleware and has a first-class support for Web Components and
 * lazy-loading. Works great in Polymer and non-Polymer apps.
 *
 * Use `new Router(outlet, options)` to create a new Router instance.
 *
 * * The `outlet` parameter is a reference to the DOM node to render
 *   the content into.
 *
 * * The `options` parameter is an optional object with options. The following
 *   keys are supported:
 *   * `baseUrl` — the initial value for [
 *     the `baseUrl` property
 *   ](#/classes/Router#property-baseUrl)
 *
 * The Router instance is automatically subscribed to navigation events
 * on `window`.
 *
 * See [Live Examples](#/classes/Router/demos/demo/index.html) for the detailed usage demo and code snippets.
 *
 * See also detailed API docs for the following methods, for the advanced usage:
 *
 * * [setOutlet](#/classes/Router#method-setOutlet) – should be used to configure the outlet.
 * * [setTriggers](#/classes/Router#method-setTriggers) – should be used to configure the navigation events.
 * * [setRoutes](#/classes/Router#method-setRoutes) – should be used to configure the routes.
 *
 * Only `setRoutes` has to be called manually, others are automatically invoked when creating a new instance.
 *
 * @extends Resolver
 * @demo demo/index.html
 * @summary JavaScript class that renders different DOM content depending on
 *    a given path. It can re-render when triggered or automatically on
 *    'popstate' and / or 'click' events.
 */ class $f9d9d110dea7aeee$export$55185c17a0fcbe46 extends $f9d9d110dea7aeee$export$8b4c839865b08288 {
    /**
   * Creates a new Router instance with a given outlet, and
   * automatically subscribes it to navigation events on the `window`.
   * Using a constructor argument or a setter for outlet is equivalent:
   *
   * ```
   * const router = new Router();
   * router.setOutlet(outlet);
   * ```
   * @param {?Node=} outlet
   * @param {?RouterOptions=} options
   */ constructor(outlet, options){
        const baseElement = document.head.querySelector("base");
        const baseHref = baseElement && baseElement.getAttribute("href");
        super([], Object.assign({
            // Default options
            baseUrl: baseHref && $f9d9d110dea7aeee$export$8b4c839865b08288.__createUrl(baseHref, document.URL).pathname.replace(/[^\/]*$/, "")
        }, options));
        this.resolveRoute = (context)=>this.__resolveRoute(context);
        const triggers = $f9d9d110dea7aeee$export$55185c17a0fcbe46.NavigationTrigger;
        $f9d9d110dea7aeee$export$55185c17a0fcbe46.setTriggers.apply($f9d9d110dea7aeee$export$55185c17a0fcbe46, Object.keys(triggers).map((key)=>triggers[key]));
        /**
     * The base URL for all routes in the router instance. By default,
     * if the base element exists in the `<head>`, vaadin-router
     * takes the `<base href>` attribute value, resolves against current `document.URL`
     * and gets the `pathname` from the result.
     *
     * @public
     * @type {string}
     */ this.baseUrl;
        /**
     * A promise that is settled after the current render cycle completes. If
     * there is no render cycle in progress the promise is immediately settled
     * with the last render cycle result.
     *
     * @public
     * @type {!Promise<!RouterLocation>}
     */ this.ready;
        this.ready = Promise.resolve(outlet);
        /**
     * Contains read-only information about the current router location:
     * pathname, active routes, parameters. See the
     * [Location type declaration](#/classes/RouterLocation)
     * for more details.
     *
     * @public
     * @type {!RouterLocation}
     */ this.location;
        this.location = $f9d9d110dea7aeee$var$createLocation({
            resolver: this
        });
        this.__lastStartedRenderId = 0;
        this.__navigationEventHandler = this.__onNavigationEvent.bind(this);
        this.setOutlet(outlet);
        this.subscribe();
        // Using WeakMap instead of WeakSet because WeakSet is not supported by IE11
        this.__createdByRouter = new WeakMap();
        this.__addedByRouter = new WeakMap();
    }
    __resolveRoute(context) {
        const route = context.route;
        let callbacks = Promise.resolve();
        if ($f9d9d110dea7aeee$var$isFunction(route.children)) callbacks = callbacks.then(()=>route.children($f9d9d110dea7aeee$var$copyContextWithoutNext(context))).then((children)=>{
            // The route.children() callback might have re-written the
            // route.children property instead of returning a value
            if (!$f9d9d110dea7aeee$var$isResultNotEmpty(children) && !$f9d9d110dea7aeee$var$isFunction(route.children)) children = route.children;
            $f9d9d110dea7aeee$var$processNewChildren(children, route);
        });
        const commands = {
            redirect: (path)=>$f9d9d110dea7aeee$var$createRedirect(context, path),
            component: (component)=>{
                const element = document.createElement(component);
                this.__createdByRouter.set(element, true);
                return element;
            }
        };
        return callbacks.then(()=>{
            if (this.__isLatestRender(context)) return $f9d9d110dea7aeee$var$runCallbackIfPossible(route.action, [
                context,
                commands
            ], route);
        }).then((result)=>{
            if ($f9d9d110dea7aeee$var$isResultNotEmpty(result)) {
                // Actions like `() => import('my-view.js')` are not expected to
                // end the resolution, despite the result is not empty. Checking
                // the result with a whitelist of values that end the resolution.
                if (result instanceof HTMLElement || result.redirect || result === $f9d9d110dea7aeee$var$notFoundResult) return result;
            }
            if ($f9d9d110dea7aeee$var$isString(route.redirect)) return commands.redirect(route.redirect);
            if (route.bundle) return $f9d9d110dea7aeee$var$loadBundle(route.bundle).then(()=>{}, ()=>{
                throw new Error($f9d9d110dea7aeee$var$log(`Bundle not found: ${route.bundle}. Check if the file name is correct`));
            });
        }).then((result)=>{
            if ($f9d9d110dea7aeee$var$isResultNotEmpty(result)) return result;
            if ($f9d9d110dea7aeee$var$isString(route.component)) return commands.component(route.component);
        });
    }
    /**
   * Sets the router outlet (the DOM node where the content for the current
   * route is inserted). Any content pre-existing in the router outlet is
   * removed at the end of each render pass.
   *
   * NOTE: this method is automatically invoked first time when creating a new Router instance.
   *
   * @param {?Node} outlet the DOM node where the content for the current route
   *     is inserted.
   */ setOutlet(outlet) {
        if (outlet) this.__ensureOutlet(outlet);
        this.__outlet = outlet;
    }
    /**
   * Returns the current router outlet. The initial value is `undefined`.
   *
   * @return {?Node} the current router outlet (or `undefined`)
   */ getOutlet() {
        return this.__outlet;
    }
    /**
   * Sets the routing config (replacing the existing one) and triggers a
   * navigation event so that the router outlet is refreshed according to the
   * current `window.location` and the new routing config.
   *
   * Each route object may have the following properties, listed here in the processing order:
   * * `path` – the route path (relative to the parent route if any) in the
   * [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   *
   * * `children` – an array of nested routes or a function that provides this
   * array at the render time. The function can be synchronous or asynchronous:
   * in the latter case the render is delayed until the returned promise is
   * resolved. The `children` function is executed every time when this route is
   * being rendered. This allows for dynamic route structures (e.g. backend-defined),
   * but it might have a performance impact as well. In order to avoid calling
   * the function on subsequent renders, you can override the `children` property
   * of the route object and save the calculated array there
   * (via `context.route.children = [ route1, route2, ...];`).
   * Parent routes are fully resolved before resolving the children. Children
   * 'path' values are relative to the parent ones.
   *
   * * `action` – the action that is executed before the route is resolved.
   * The value for this property should be a function, accepting `context`
   * and `commands` parameters described below. If present, this function is
   * always invoked first, disregarding of the other properties' presence.
   * The action can return a result directly or within a `Promise`, which
   * resolves to the result. If the action result is an `HTMLElement` instance,
   * a `commands.component(name)` result, a `commands.redirect(path)` result,
   * or a `context.next()` result, the current route resolution is finished,
   * and other route config properties are ignored.
   * See also **Route Actions** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `redirect` – other route's path to redirect to. Passes all route parameters to the redirect target.
   * The target route should also be defined.
   * See also **Redirects** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `bundle` – string containing the path to `.js` or `.mjs` bundle to load before resolving the route,
   * or the object with "module" and "nomodule" keys referring to different bundles.
   * Each bundle is only loaded once. If "module" and "nomodule" are set, only one bundle is loaded,
   * depending on whether the browser supports ES modules or not.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * Any error, e.g. 404 while loading bundle will cause route resolution to throw.
   * See also **Code Splitting** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * * `component` – the tag name of the Web Component to resolve the route to.
   * The property is ignored when either an `action` returns the result or `redirect` property is present.
   * If route contains the `component` property (or an action that return a component)
   * and its child route also contains the `component` property, child route's component
   * will be rendered as a light dom child of a parent component.
   *
   * * `name` – the string name of the route to use in the
   * [`router.urlForName(name, params)`](#/classes/Router#method-urlForName)
   * navigation helper method.
   *
   * For any route function (`action`, `children`) defined, the corresponding `route` object is available inside the callback
   * through the `this` reference. If you need to access it, make sure you define the callback as a non-arrow function
   * because arrow functions do not have their own `this` reference.
   *
   * `context` object that is passed to `action` function holds the following properties:
   * * `context.pathname` – string with the pathname being resolved
   *
   * * `context.search` – search query string
   *
   * * `context.hash` – hash string
   *
   * * `context.params` – object with route parameters
   *
   * * `context.route` – object that holds the route that is currently being rendered.
   *
   * * `context.next()` – function for asynchronously getting the next route
   * contents from the resolution chain (if any)
   *
   * `commands` object that is passed to `action` function has
   * the following methods:
   *
   * * `commands.redirect(path)` – function that creates a redirect data
   * for the path specified.
   *
   * * `commands.component(component)` – function that creates a new HTMLElement
   * with current context. Note: the component created by this function is reused if visiting the same path twice in row.
   *
   *
   * @param {!Array<!Route>|!Route} routes a single route or an array of those
   * @param {?boolean} skipRender configure the router but skip rendering the
   *     route corresponding to the current `window.location` values
   *
   * @return {!Promise<!Node>}
   */ setRoutes(routes, skipRender = false) {
        this.__previousContext = undefined;
        this.__urlForName = undefined;
        super.setRoutes(routes);
        if (!skipRender) this.__onNavigationEvent();
        return this.ready;
    }
    /**
   * Asynchronously resolves the given pathname and renders the resolved route
   * component into the router outlet. If no router outlet is set at the time of
   * calling this method, or at the time when the route resolution is completed,
   * a `TypeError` is thrown.
   *
   * Returns a promise that is fulfilled with the router outlet DOM Node after
   * the route component is created and inserted into the router outlet, or
   * rejected if no route matches the given path.
   *
   * If another render pass is started before the previous one is completed, the
   * result of the previous render pass is ignored.
   *
   * @param {!string|!{pathname: !string, search: ?string, hash: ?string}} pathnameOrContext
   *    the pathname to render or a context object with a `pathname` property,
   *    optional `search` and `hash` properties, and other properties
   *    to pass to the resolver.
   * @param {boolean=} shouldUpdateHistory
   *    update browser history with the rendered location
   * @return {!Promise<!Node>}
   */ render(pathnameOrContext, shouldUpdateHistory) {
        const renderId = ++this.__lastStartedRenderId;
        const context = Object.assign({
            search: "",
            hash: ""
        }, $f9d9d110dea7aeee$var$isString(pathnameOrContext) ? {
            pathname: pathnameOrContext
        } : pathnameOrContext, {
            __renderId: renderId
        });
        // Find the first route that resolves to a non-empty result
        this.ready = this.resolve(context)// Process the result of this.resolve() and handle all special commands:
        // (redirect / prevent / component). If the result is a 'component',
        // then go deeper and build the entire chain of nested components matching
        // the pathname. Also call all 'on before' callbacks along the way.
        .then((context)=>this.__fullyResolveChain(context)).then((context)=>{
            if (this.__isLatestRender(context)) {
                const previousContext = this.__previousContext;
                // Check if the render was prevented and make an early return in that case
                if (context === previousContext) {
                    // Replace the history with the previous context
                    // to make sure the URL stays the same.
                    this.__updateBrowserHistory(previousContext, true);
                    return this.location;
                }
                this.location = $f9d9d110dea7aeee$var$createLocation(context);
                if (shouldUpdateHistory) // Replace only if first render redirects, so that we don’t leave
                // the redirecting record in the history
                this.__updateBrowserHistory(context, renderId === 1);
                $f9d9d110dea7aeee$var$fireRouterEvent("location-changed", {
                    router: this,
                    location: this.location
                });
                // Skip detaching/re-attaching there are no render changes
                if (context.__skipAttach) {
                    this.__copyUnchangedElements(context, previousContext);
                    this.__previousContext = context;
                    return this.location;
                }
                this.__addAppearingContent(context, previousContext);
                const animationDone = this.__animateIfNeeded(context);
                this.__runOnAfterEnterCallbacks(context);
                this.__runOnAfterLeaveCallbacks(context, previousContext);
                return animationDone.then(()=>{
                    if (this.__isLatestRender(context)) {
                        // If there is another render pass started after this one,
                        // the 'disappearing content' would be removed when the other
                        // render pass calls `this.__addAppearingContent()`
                        this.__removeDisappearingContent();
                        this.__previousContext = context;
                        return this.location;
                    }
                });
            }
        }).catch((error)=>{
            if (renderId === this.__lastStartedRenderId) {
                if (shouldUpdateHistory) this.__updateBrowserHistory(context);
                $f9d9d110dea7aeee$var$removeDomNodes(this.__outlet && this.__outlet.children);
                this.location = $f9d9d110dea7aeee$var$createLocation(Object.assign(context, {
                    resolver: this
                }));
                $f9d9d110dea7aeee$var$fireRouterEvent("error", Object.assign({
                    router: this,
                    error: error
                }, context));
                throw error;
            }
        });
        return this.ready;
    }
    // `topOfTheChainContextBeforeRedirects` is a context coming from Resolver.resolve().
    // It would contain a 'redirect' route or the first 'component' route that
    // matched the pathname. There might be more child 'component' routes to be
    // resolved and added into the chain. This method would find and add them.
    // `contextBeforeRedirects` is the context containing such a child component
    // route. It's only necessary when this method is called recursively (otherwise
    // it's the same as the 'top of the chain' context).
    //
    // Apart from building the chain of child components, this method would also
    // handle 'redirect' routes, call 'onBefore' callbacks and handle 'prevent'
    // and 'redirect' callback results.
    __fullyResolveChain(topOfTheChainContextBeforeRedirects, contextBeforeRedirects = topOfTheChainContextBeforeRedirects) {
        return this.__findComponentContextAfterAllRedirects(contextBeforeRedirects)// `contextAfterRedirects` is always a context with an `HTMLElement` result
        // In other cases the promise gets rejected and .then() is not called
        .then((contextAfterRedirects)=>{
            const redirectsHappened = contextAfterRedirects !== contextBeforeRedirects;
            const topOfTheChainContextAfterRedirects = redirectsHappened ? contextAfterRedirects : topOfTheChainContextBeforeRedirects;
            const matchedPath = $f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$var$getMatchedPath(contextAfterRedirects.chain), contextAfterRedirects.resolver);
            const isFound = matchedPath === contextAfterRedirects.pathname;
            // Recursive method to try matching more child and sibling routes
            const findNextContextIfAny = (context, parent = context.route, prevResult)=>{
                return context.next(undefined, parent, prevResult).then((nextContext)=>{
                    if (nextContext === null || nextContext === $f9d9d110dea7aeee$var$notFoundResult) {
                        // Next context is not found in children, ...
                        if (isFound) // ...but original context is already fully matching - use it
                        return context;
                        else if (parent.parent !== null) // ...and there is no full match yet - step up to check siblings
                        return findNextContextIfAny(context, parent.parent, nextContext);
                        else return nextContext;
                    }
                    return nextContext;
                });
            };
            return findNextContextIfAny(contextAfterRedirects).then((nextContext)=>{
                if (nextContext === null || nextContext === $f9d9d110dea7aeee$var$notFoundResult) throw $f9d9d110dea7aeee$var$getNotFoundError(topOfTheChainContextAfterRedirects);
                return nextContext && nextContext !== $f9d9d110dea7aeee$var$notFoundResult && nextContext !== contextAfterRedirects ? this.__fullyResolveChain(topOfTheChainContextAfterRedirects, nextContext) : this.__amendWithOnBeforeCallbacks(contextAfterRedirects);
            });
        });
    }
    __findComponentContextAfterAllRedirects(context) {
        const result = context.result;
        if (result instanceof HTMLElement) {
            $f9d9d110dea7aeee$var$renderElement(context, result);
            return Promise.resolve(context);
        } else if (result.redirect) return this.__redirect(result.redirect, context.__redirectCount, context.__renderId).then((context)=>this.__findComponentContextAfterAllRedirects(context));
        else if (result instanceof Error) return Promise.reject(result);
        else return Promise.reject(new Error($f9d9d110dea7aeee$var$log(`Invalid route resolution result for path "${context.pathname}". ` + `Expected redirect object or HTML element, but got: "${$f9d9d110dea7aeee$var$logValue(result)}". ` + `Double check the action return value for the route.`)));
    }
    __amendWithOnBeforeCallbacks(contextWithFullChain) {
        return this.__runOnBeforeCallbacks(contextWithFullChain).then((amendedContext)=>{
            if (amendedContext === this.__previousContext || amendedContext === contextWithFullChain) return amendedContext;
            return this.__fullyResolveChain(amendedContext);
        });
    }
    __runOnBeforeCallbacks(newContext) {
        const previousContext = this.__previousContext || {};
        const previousChain = previousContext.chain || [];
        const newChain = newContext.chain;
        let callbacks = Promise.resolve();
        const prevent = ()=>({
                cancel: true
            });
        const redirect = (pathname)=>$f9d9d110dea7aeee$var$createRedirect(newContext, pathname);
        newContext.__divergedChainIndex = 0;
        newContext.__skipAttach = false;
        if (previousChain.length) {
            for(let i = 0; i < Math.min(previousChain.length, newChain.length); i = ++newContext.__divergedChainIndex){
                if (previousChain[i].route !== newChain[i].route || previousChain[i].path !== newChain[i].path && previousChain[i].element !== newChain[i].element || !this.__isReusableElement(previousChain[i].element, newChain[i].element)) break;
            }
            // Skip re-attaching and notifications if element and chain do not change
            newContext.__skipAttach = // Same route chain
            newChain.length === previousChain.length && newContext.__divergedChainIndex == newChain.length && // Same element
            this.__isReusableElement(newContext.result, previousContext.result);
            if (newContext.__skipAttach) {
                // execute onBeforeLeave for changed segment element when skipping attach
                for(let i = newChain.length - 1; i >= 0; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                    prevent: prevent
                }, previousChain[i]);
                // execute onBeforeEnter for changed segment element when skipping attach
                for(let i = 0; i < newChain.length; i++){
                    callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                        prevent: prevent,
                        redirect: redirect
                    }, newChain[i]);
                    previousChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, previousChain[i].route);
                }
            } else // execute onBeforeLeave when NOT skipping attach
            for(let i = previousChain.length - 1; i >= newContext.__divergedChainIndex; i--)callbacks = this.__runOnBeforeLeaveCallbacks(callbacks, newContext, {
                prevent: prevent
            }, previousChain[i]);
        }
        // execute onBeforeEnter when NOT skipping attach
        if (!newContext.__skipAttach) for(let i = 0; i < newChain.length; i++){
            if (i < newContext.__divergedChainIndex) {
                if (i < previousChain.length && previousChain[i].element) previousChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, previousChain[i].route);
            } else {
                callbacks = this.__runOnBeforeEnterCallbacks(callbacks, newContext, {
                    prevent: prevent,
                    redirect: redirect
                }, newChain[i]);
                if (newChain[i].element) newChain[i].element.location = $f9d9d110dea7aeee$var$createLocation(newContext, newChain[i].route);
            }
        }
        return callbacks.then((amendmentResult)=>{
            if (amendmentResult) {
                if (amendmentResult.cancel) {
                    this.__previousContext.__renderId = newContext.__renderId;
                    return this.__previousContext;
                }
                if (amendmentResult.redirect) return this.__redirect(amendmentResult.redirect, newContext.__redirectCount, newContext.__renderId);
            }
            return newContext;
        });
    }
    __runOnBeforeLeaveCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f9d9d110dea7aeee$var$createLocation(newContext);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const afterLeaveFunction = $f9d9d110dea7aeee$var$amend("onBeforeLeave", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return afterLeaveFunction(result);
            }
        }).then((result)=>{
            if (!(result || {}).redirect) return result;
        });
    }
    __runOnBeforeEnterCallbacks(callbacks, newContext, commands, chainElement) {
        const location = $f9d9d110dea7aeee$var$createLocation(newContext, chainElement.route);
        return callbacks.then((result)=>{
            if (this.__isLatestRender(newContext)) {
                const beforeEnterFunction = $f9d9d110dea7aeee$var$amend("onBeforeEnter", [
                    location,
                    commands,
                    this
                ], chainElement.element);
                return beforeEnterFunction(result);
            }
        });
    }
    __isReusableElement(element, otherElement) {
        if (element && otherElement) return this.__createdByRouter.get(element) && this.__createdByRouter.get(otherElement) ? element.localName === otherElement.localName : element === otherElement;
        return false;
    }
    __isLatestRender(context) {
        return context.__renderId === this.__lastStartedRenderId;
    }
    __redirect(redirectData, counter, renderId) {
        if (counter > $f9d9d110dea7aeee$var$MAX_REDIRECT_COUNT) throw new Error($f9d9d110dea7aeee$var$log(`Too many redirects when rendering ${redirectData.from}`));
        return this.resolve({
            pathname: this.urlForPath(redirectData.pathname, redirectData.params),
            redirectFrom: redirectData.from,
            __redirectCount: (counter || 0) + 1,
            __renderId: renderId
        });
    }
    __ensureOutlet(outlet = this.__outlet) {
        if (!(outlet instanceof Node)) throw new TypeError($f9d9d110dea7aeee$var$log(`Expected router outlet to be a valid DOM Node (but got ${outlet})`));
    }
    __updateBrowserHistory({ pathname: pathname, search: search = "", hash: hash = "" }, replace) {
        if (window.location.pathname !== pathname || window.location.search !== search || window.location.hash !== hash) {
            const changeState = replace ? "replaceState" : "pushState";
            window.history[changeState](null, document.title, pathname + search + hash);
            window.dispatchEvent(new PopStateEvent("popstate", {
                state: "vaadin-router-ignore"
            }));
        }
    }
    __copyUnchangedElements(context, previousContext) {
        // Find the deepest common parent between the last and the new component
        // chains. Update references for the unchanged elements in the new chain
        let deepestCommonParent = this.__outlet;
        for(let i = 0; i < context.__divergedChainIndex; i++){
            const unchangedElement = previousContext && previousContext.chain[i].element;
            if (unchangedElement) {
                if (unchangedElement.parentNode === deepestCommonParent) {
                    context.chain[i].element = unchangedElement;
                    deepestCommonParent = unchangedElement;
                } else break;
            }
        }
        return deepestCommonParent;
    }
    __addAppearingContent(context, previousContext) {
        this.__ensureOutlet();
        // If the previous 'entering' animation has not completed yet,
        // stop it and remove that content from the DOM before adding new one.
        this.__removeAppearingContent();
        // Copy reusable elements from the previousContext to current
        const deepestCommonParent = this.__copyUnchangedElements(context, previousContext);
        // Keep two lists of DOM elements:
        //  - those that should be removed once the transition animation is over
        //  - and those that should remain
        this.__appearingContent = [];
        this.__disappearingContent = Array.from(deepestCommonParent.children).filter(// Only remove layout content that was added by router
        (e)=>this.__addedByRouter.get(e) && // Do not remove the result element to avoid flickering
            e !== context.result);
        // Add new elements (starting after the deepest common parent) to the DOM.
        // That way only the components that are actually different between the two
        // locations are added to the DOM (and those that are common remain in the
        // DOM without first removing and then adding them again).
        let parentElement = deepestCommonParent;
        for(let i = context.__divergedChainIndex; i < context.chain.length; i++){
            const elementToAdd = context.chain[i].element;
            if (elementToAdd) {
                parentElement.appendChild(elementToAdd);
                this.__addedByRouter.set(elementToAdd, true);
                if (parentElement === deepestCommonParent) this.__appearingContent.push(elementToAdd);
                parentElement = elementToAdd;
            }
        }
    }
    __removeDisappearingContent() {
        if (this.__disappearingContent) $f9d9d110dea7aeee$var$removeDomNodes(this.__disappearingContent);
        this.__disappearingContent = null;
        this.__appearingContent = null;
    }
    __removeAppearingContent() {
        if (this.__disappearingContent && this.__appearingContent) {
            $f9d9d110dea7aeee$var$removeDomNodes(this.__appearingContent);
            this.__disappearingContent = null;
            this.__appearingContent = null;
        }
    }
    __runOnAfterLeaveCallbacks(currentContext, targetContext) {
        if (!targetContext) return;
        // REVERSE iteration: from Z to A
        for(let i = targetContext.chain.length - 1; i >= currentContext.__divergedChainIndex; i--){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = targetContext.chain[i].element;
            if (!currentComponent) continue;
            try {
                const location = $f9d9d110dea7aeee$var$createLocation(currentContext);
                $f9d9d110dea7aeee$var$runCallbackIfPossible(currentComponent.onAfterLeave, [
                    location,
                    {},
                    targetContext.resolver
                ], currentComponent);
            } finally{
                if (this.__disappearingContent.indexOf(currentComponent) > -1) $f9d9d110dea7aeee$var$removeDomNodes(currentComponent.children);
            }
        }
    }
    __runOnAfterEnterCallbacks(currentContext) {
        // forward iteration: from A to Z
        for(let i = currentContext.__divergedChainIndex; i < currentContext.chain.length; i++){
            if (!this.__isLatestRender(currentContext)) break;
            const currentComponent = currentContext.chain[i].element || {};
            const location = $f9d9d110dea7aeee$var$createLocation(currentContext, currentContext.chain[i].route);
            $f9d9d110dea7aeee$var$runCallbackIfPossible(currentComponent.onAfterEnter, [
                location,
                {},
                currentContext.resolver
            ], currentComponent);
        }
    }
    __animateIfNeeded(context) {
        const from = (this.__disappearingContent || [])[0];
        const to = (this.__appearingContent || [])[0];
        const promises = [];
        const chain = context.chain;
        let config;
        for(let i = chain.length; i > 0; i--)if (chain[i - 1].route.animate) {
            config = chain[i - 1].route.animate;
            break;
        }
        if (from && to && config) {
            const leave = $f9d9d110dea7aeee$var$isObject(config) && config.leave || "leaving";
            const enter = $f9d9d110dea7aeee$var$isObject(config) && config.enter || "entering";
            promises.push($f9d9d110dea7aeee$var$animate(from, leave));
            promises.push($f9d9d110dea7aeee$var$animate(to, enter));
        }
        return Promise.all(promises).then(()=>context);
    }
    /**
   * Subscribes this instance to navigation events on the `window`.
   *
   * NOTE: beware of resource leaks. For as long as a router instance is
   * subscribed to navigation events, it won't be garbage collected.
   */ subscribe() {
        window.addEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    /**
   * Removes the subscription to navigation events created in the `subscribe()`
   * method.
   */ unsubscribe() {
        window.removeEventListener("vaadin-router-go", this.__navigationEventHandler);
    }
    __onNavigationEvent(event) {
        const { pathname: pathname, search: search, hash: hash } = event ? event.detail : window.location;
        if ($f9d9d110dea7aeee$var$isString(this.__normalizePathname(pathname))) {
            if (event && event.preventDefault) event.preventDefault();
            this.render({
                pathname: pathname,
                search: search,
                hash: hash
            }, true);
        }
    }
    /**
   * Configures what triggers Router navigation events:
   *  - `POPSTATE`: popstate events on the current `window`
   *  - `CLICK`: click events on `<a>` links leading to the current page
   *
   * This method is invoked with the pre-configured values when creating a new Router instance.
   * By default, both `POPSTATE` and `CLICK` are enabled. This setup is expected to cover most of the use cases.
   *
   * See the `router-config.js` for the default navigation triggers config. Based on it, you can
   * create the own one and only import the triggers you need, instead of pulling in all the code,
   * e.g. if you want to handle `click` differently.
   *
   * See also **Navigation Triggers** section in [Live Examples](#/classes/Router/demos/demo/index.html).
   *
   * @param {...NavigationTrigger} triggers
   */ static setTriggers(...triggers) {
        $f9d9d110dea7aeee$var$setNavigationTriggers(triggers);
    }
    /**
   * Generates a URL for the route with the given name, optionally performing
   * substitution of parameters.
   *
   * The route is searched in all the Router instances subscribed to
   * navigation events.
   *
   * **Note:** For child route names, only array children are considered.
   * It is not possible to generate URLs using a name for routes set with
   * a children function.
   *
   * @function urlForName
   * @param {!string} name the route name or the route’s `component` name.
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForName(name, params) {
        if (!this.__urlForName) this.__urlForName = $f9d9d110dea7aeee$var$generateUrls(this);
        return $f9d9d110dea7aeee$var$getPathnameForRouter(this.__urlForName(name, params), this);
    }
    /**
   * Generates a URL for the given route path, optionally performing
   * substitution of parameters.
   *
   * @param {!string} path string route path declared in [express.js syntax](https://expressjs.com/en/guide/routing.html#route-paths").
   * @param {Params=} params Optional object with route path parameters.
   * Named parameters are passed by name (`params[name] = value`), unnamed
   * parameters are passed by index (`params[index] = value`).
   *
   * @return {string}
   */ urlForPath(path, params) {
        return $f9d9d110dea7aeee$var$getPathnameForRouter($f9d9d110dea7aeee$export$55185c17a0fcbe46.pathToRegexp.compile(path)(params), this);
    }
    /**
   * Triggers navigation to a new path. Returns a boolean without waiting until
   * the navigation is complete. Returns `true` if at least one `Router`
   * has handled the navigation (was subscribed and had `baseUrl` matching
   * the `path` argument), otherwise returns `false`.
   *
   * @param {!string|!{pathname: !string, search: (string|undefined), hash: (string|undefined)}} path
   *   a new in-app path string, or an URL-like object with `pathname`
   *   string property, and optional `search` and `hash` string properties.
   * @return {boolean}
   */ static go(path) {
        const { pathname: pathname, search: search, hash: hash } = $f9d9d110dea7aeee$var$isString(path) ? this.__createUrl(path, "http://a") // some base to omit origin
         : path;
        return $f9d9d110dea7aeee$var$fireRouterEvent("go", {
            pathname: pathname,
            search: search,
            hash: hash
        });
    }
}
const $f9d9d110dea7aeee$var$DEV_MODE_CODE_REGEXP = /\/\*[\*!]\s+vaadin-dev-mode:start([\s\S]*)vaadin-dev-mode:end\s+\*\*\//i;
const $f9d9d110dea7aeee$var$FlowClients = window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients;
function $f9d9d110dea7aeee$var$isMinified() {
    function test() {
        /** vaadin-dev-mode:start
    return false;
    vaadin-dev-mode:end **/ return true;
    }
    return $f9d9d110dea7aeee$var$uncommentAndRun(test);
}
function $f9d9d110dea7aeee$var$isDevelopmentMode() {
    try {
        if ($f9d9d110dea7aeee$var$isForcedDevelopmentMode()) return true;
        if (!$f9d9d110dea7aeee$var$isLocalhost()) return false;
        if ($f9d9d110dea7aeee$var$FlowClients) return !$f9d9d110dea7aeee$var$isFlowProductionMode();
        return !$f9d9d110dea7aeee$var$isMinified();
    } catch (e) {
        // Some error in this code, assume production so no further actions will be taken
        return false;
    }
}
function $f9d9d110dea7aeee$var$isForcedDevelopmentMode() {
    return localStorage.getItem("vaadin.developmentmode.force");
}
function $f9d9d110dea7aeee$var$isLocalhost() {
    return [
        "localhost",
        "127.0.0.1"
    ].indexOf(window.location.hostname) >= 0;
}
function $f9d9d110dea7aeee$var$isFlowProductionMode() {
    if ($f9d9d110dea7aeee$var$FlowClients) {
        const productionModeApps = Object.keys($f9d9d110dea7aeee$var$FlowClients).map((key)=>$f9d9d110dea7aeee$var$FlowClients[key]).filter((client)=>client.productionMode);
        if (productionModeApps.length > 0) return true;
    }
    return false;
}
function $f9d9d110dea7aeee$var$uncommentAndRun(callback, args) {
    if (typeof callback !== "function") return;
    const match = $f9d9d110dea7aeee$var$DEV_MODE_CODE_REGEXP.exec(callback.toString());
    if (match) try {
        // requires CSP: script-src 'unsafe-eval'
        callback = new Function(match[1]);
    } catch (e) {
        // eat the exception
        console.log("vaadin-development-mode-detector: uncommentAndRun() failed", e);
    }
    return callback(args);
}
// A guard against polymer-modulizer removing the window.Vaadin
// initialization above.
window["Vaadin"] = window["Vaadin"] || {};
/**
 * Inspects the source code of the given `callback` function for
 * specially-marked _commented_ code. If such commented code is found in the
 * callback source, uncomments and runs that code instead of the callback
 * itself. Otherwise runs the callback as is.
 *
 * The optional arguments are passed into the callback / uncommented code,
 * the result is returned.
 *
 * See the `isMinified()` function source code in this file for an example.
 *
 */ const $f9d9d110dea7aeee$var$runIfDevelopmentMode = function(callback, args) {
    if (window.Vaadin.developmentMode) return $f9d9d110dea7aeee$var$uncommentAndRun(callback, args);
};
if (window.Vaadin.developmentMode === undefined) window.Vaadin.developmentMode = $f9d9d110dea7aeee$var$isDevelopmentMode();
/* This file is autogenerated from src/vaadin-usage-statistics.tpl.html */ function $f9d9d110dea7aeee$var$maybeGatherAndSendStats() {
/** vaadin-dev-mode:start
  (function () {
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var getPolymerVersion = function getPolymerVersion() {
  return window.Polymer && window.Polymer.version;
};

var StatisticsGatherer = function () {
  function StatisticsGatherer(logger) {
    classCallCheck(this, StatisticsGatherer);

    this.now = new Date().getTime();
    this.logger = logger;
  }

  createClass(StatisticsGatherer, [{
    key: 'frameworkVersionDetectors',
    value: function frameworkVersionDetectors() {
      return {
        'Flow': function Flow() {
          if (window.Vaadin && window.Vaadin.Flow && window.Vaadin.Flow.clients) {
            var flowVersions = Object.keys(window.Vaadin.Flow.clients).map(function (key) {
              return window.Vaadin.Flow.clients[key];
            }).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().flow;
            });
            if (flowVersions.length > 0) {
              return flowVersions[0];
            }
          }
        },
        'Vaadin Framework': function VaadinFramework() {
          if (window.vaadin && window.vaadin.clients) {
            var frameworkVersions = Object.values(window.vaadin.clients).filter(function (client) {
              return client.getVersionInfo;
            }).map(function (client) {
              return client.getVersionInfo().vaadinVersion;
            });
            if (frameworkVersions.length > 0) {
              return frameworkVersions[0];
            }
          }
        },
        'AngularJs': function AngularJs() {
          if (window.angular && window.angular.version && window.angular.version) {
            return window.angular.version.full;
          }
        },
        'Angular': function Angular() {
          if (window.ng) {
            var tags = document.querySelectorAll("[ng-version]");
            if (tags.length > 0) {
              return tags[0].getAttribute("ng-version");
            }
            return "Unknown";
          }
        },
        'Backbone.js': function BackboneJs() {
          if (window.Backbone) {
            return window.Backbone.VERSION;
          }
        },
        'React': function React() {
          var reactSelector = '[data-reactroot], [data-reactid]';
          if (!!document.querySelector(reactSelector)) {
            // React does not publish the version by default
            return "unknown";
          }
        },
        'Ember': function Ember() {
          if (window.Em && window.Em.VERSION) {
            return window.Em.VERSION;
          } else if (window.Ember && window.Ember.VERSION) {
            return window.Ember.VERSION;
          }
        },
        'jQuery': function (_jQuery) {
          function jQuery() {
            return _jQuery.apply(this, arguments);
          }

          jQuery.toString = function () {
            return _jQuery.toString();
          };

          return jQuery;
        }(function () {
          if (typeof jQuery === 'function' && jQuery.prototype.jquery !== undefined) {
            return jQuery.prototype.jquery;
          }
        }),
        'Polymer': function Polymer() {
          var version = getPolymerVersion();
          if (version) {
            return version;
          }
        },
        'LitElement': function LitElement() {
          var version = window.litElementVersions && window.litElementVersions[0];
          if (version) {
            return version;
          }
        },
        'LitHtml': function LitHtml() {
          var version = window.litHtmlVersions && window.litHtmlVersions[0];
          if (version) {
            return version;
          }
        },
        'Vue.js': function VueJs() {
          if (window.Vue) {
            return window.Vue.version;
          }
        }
      };
    }
  }, {
    key: 'getUsedVaadinElements',
    value: function getUsedVaadinElements(elements) {
      var version = getPolymerVersion();
      var elementClasses = void 0;
      // NOTE: In case you edit the code here, YOU MUST UPDATE any statistics reporting code in Flow.
      // Check all locations calling the method getEntries() in
      // https://github.com/vaadin/flow/blob/master/flow-server/src/main/java/com/vaadin/flow/internal/UsageStatistics.java#L106
      // Currently it is only used by BootstrapHandler.
      if (version && version.indexOf('2') === 0) {
        // Polymer 2: components classes are stored in window.Vaadin
        elementClasses = Object.keys(window.Vaadin).map(function (c) {
          return window.Vaadin[c];
        }).filter(function (c) {
          return c.is;
        });
      } else {
        // Polymer 3: components classes are stored in window.Vaadin.registrations
        elementClasses = window.Vaadin.registrations || [];
      }
      elementClasses.forEach(function (klass) {
        var version = klass.version ? klass.version : "0.0.0";
        elements[klass.is] = { version: version };
      });
    }
  }, {
    key: 'getUsedVaadinThemes',
    value: function getUsedVaadinThemes(themes) {
      ['Lumo', 'Material'].forEach(function (themeName) {
        var theme;
        var version = getPolymerVersion();
        if (version && version.indexOf('2') === 0) {
          // Polymer 2: themes are stored in window.Vaadin
          theme = window.Vaadin[themeName];
        } else {
          // Polymer 3: themes are stored in custom element registry
          theme = customElements.get('vaadin-' + themeName.toLowerCase() + '-styles');
        }
        if (theme && theme.version) {
          themes[themeName] = { version: theme.version };
        }
      });
    }
  }, {
    key: 'getFrameworks',
    value: function getFrameworks(frameworks) {
      var detectors = this.frameworkVersionDetectors();
      Object.keys(detectors).forEach(function (framework) {
        var detector = detectors[framework];
        try {
          var version = detector();
          if (version) {
            frameworks[framework] = { version: version };
          }
        } catch (e) {}
      });
    }
  }, {
    key: 'gather',
    value: function gather(storage) {
      var storedStats = storage.read();
      var gatheredStats = {};
      var types = ["elements", "frameworks", "themes"];

      types.forEach(function (type) {
        gatheredStats[type] = {};
        if (!storedStats[type]) {
          storedStats[type] = {};
        }
      });

      var previousStats = JSON.stringify(storedStats);

      this.getUsedVaadinElements(gatheredStats.elements);
      this.getFrameworks(gatheredStats.frameworks);
      this.getUsedVaadinThemes(gatheredStats.themes);

      var now = this.now;
      types.forEach(function (type) {
        var keys = Object.keys(gatheredStats[type]);
        keys.forEach(function (key) {
          if (!storedStats[type][key] || _typeof(storedStats[type][key]) != _typeof({})) {
            storedStats[type][key] = { firstUsed: now };
          }
          // Discards any previously logged version number
          storedStats[type][key].version = gatheredStats[type][key].version;
          storedStats[type][key].lastUsed = now;
        });
      });

      var newStats = JSON.stringify(storedStats);
      storage.write(newStats);
      if (newStats != previousStats && Object.keys(storedStats).length > 0) {
        this.logger.debug("New stats: " + newStats);
      }
    }
  }]);
  return StatisticsGatherer;
}();

var StatisticsStorage = function () {
  function StatisticsStorage(key) {
    classCallCheck(this, StatisticsStorage);

    this.key = key;
  }

  createClass(StatisticsStorage, [{
    key: 'read',
    value: function read() {
      var localStorageStatsString = localStorage.getItem(this.key);
      try {
        return JSON.parse(localStorageStatsString ? localStorageStatsString : '{}');
      } catch (e) {
        return {};
      }
    }
  }, {
    key: 'write',
    value: function write(data) {
      localStorage.setItem(this.key, data);
    }
  }, {
    key: 'clear',
    value: function clear() {
      localStorage.removeItem(this.key);
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      var storedStats = this.read();
      var empty = true;
      Object.keys(storedStats).forEach(function (key) {
        if (Object.keys(storedStats[key]).length > 0) {
          empty = false;
        }
      });

      return empty;
    }
  }]);
  return StatisticsStorage;
}();

var StatisticsSender = function () {
  function StatisticsSender(url, logger) {
    classCallCheck(this, StatisticsSender);

    this.url = url;
    this.logger = logger;
  }

  createClass(StatisticsSender, [{
    key: 'send',
    value: function send(data, errorHandler) {
      var logger = this.logger;

      if (navigator.onLine === false) {
        logger.debug("Offline, can't send");
        errorHandler();
        return;
      }
      logger.debug("Sending data to " + this.url);

      var req = new XMLHttpRequest();
      req.withCredentials = true;
      req.addEventListener("load", function () {
        // Stats sent, nothing more to do
        logger.debug("Response: " + req.responseText);
      });
      req.addEventListener("error", function () {
        logger.debug("Send failed");
        errorHandler();
      });
      req.addEventListener("abort", function () {
        logger.debug("Send aborted");
        errorHandler();
      });
      req.open("POST", this.url);
      req.setRequestHeader("Content-Type", "application/json");
      req.send(data);
    }
  }]);
  return StatisticsSender;
}();

var StatisticsLogger = function () {
  function StatisticsLogger(id) {
    classCallCheck(this, StatisticsLogger);

    this.id = id;
  }

  createClass(StatisticsLogger, [{
    key: '_isDebug',
    value: function _isDebug() {
      return localStorage.getItem("vaadin." + this.id + ".debug");
    }
  }, {
    key: 'debug',
    value: function debug(msg) {
      if (this._isDebug()) {
        console.info(this.id + ": " + msg);
      }
    }
  }]);
  return StatisticsLogger;
}();

var UsageStatistics = function () {
  function UsageStatistics() {
    classCallCheck(this, UsageStatistics);

    this.now = new Date();
    this.timeNow = this.now.getTime();
    this.gatherDelay = 10; // Delay between loading this file and gathering stats
    this.initialDelay = 24 * 60 * 60;

    this.logger = new StatisticsLogger("statistics");
    this.storage = new StatisticsStorage("vaadin.statistics.basket");
    this.gatherer = new StatisticsGatherer(this.logger);
    this.sender = new StatisticsSender("https://tools.vaadin.com/usage-stats/submit", this.logger);
  }

  createClass(UsageStatistics, [{
    key: 'maybeGatherAndSend',
    value: function maybeGatherAndSend() {
      var _this = this;

      if (localStorage.getItem(UsageStatistics.optOutKey)) {
        return;
      }
      this.gatherer.gather(this.storage);
      setTimeout(function () {
        _this.maybeSend();
      }, this.gatherDelay * 1000);
    }
  }, {
    key: 'lottery',
    value: function lottery() {
      return true;
    }
  }, {
    key: 'currentMonth',
    value: function currentMonth() {
      return this.now.getYear() * 12 + this.now.getMonth();
    }
  }, {
    key: 'maybeSend',
    value: function maybeSend() {
      var firstUse = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      var monthProcessed = Number(localStorage.getItem(UsageStatistics.monthProcessedKey));

      if (!firstUse) {
        // Use a grace period to avoid interfering with tests, incognito mode etc
        firstUse = this.timeNow;
        localStorage.setItem(UsageStatistics.firstUseKey, firstUse);
      }

      if (this.timeNow < firstUse + this.initialDelay * 1000) {
        this.logger.debug("No statistics will be sent until the initial delay of " + this.initialDelay + "s has passed");
        return;
      }
      if (this.currentMonth() <= monthProcessed) {
        this.logger.debug("This month has already been processed");
        return;
      }
      localStorage.setItem(UsageStatistics.monthProcessedKey, this.currentMonth());
      // Use random sampling
      if (this.lottery()) {
        this.logger.debug("Congratulations, we have a winner!");
      } else {
        this.logger.debug("Sorry, no stats from you this time");
        return;
      }

      this.send();
    }
  }, {
    key: 'send',
    value: function send() {
      // Ensure we have the latest data
      this.gatherer.gather(this.storage);

      // Read, send and clean up
      var data = this.storage.read();
      data["firstUse"] = Number(localStorage.getItem(UsageStatistics.firstUseKey));
      data["usageStatisticsVersion"] = UsageStatistics.version;
      var info = 'This request contains usage statistics gathered from the application running in development mode. \n\nStatistics gathering is automatically disabled and excluded from production builds.\n\nFor details and to opt-out, see https://github.com/vaadin/vaadin-usage-statistics.\n\n\n\n';
      var self = this;
      this.sender.send(info + JSON.stringify(data), function () {
        // Revert the 'month processed' flag
        localStorage.setItem(UsageStatistics.monthProcessedKey, self.currentMonth() - 1);
      });
    }
  }], [{
    key: 'version',
    get: function get$1() {
      return '2.1.2';
    }
  }, {
    key: 'firstUseKey',
    get: function get$1() {
      return 'vaadin.statistics.firstuse';
    }
  }, {
    key: 'monthProcessedKey',
    get: function get$1() {
      return 'vaadin.statistics.monthProcessed';
    }
  }, {
    key: 'optOutKey',
    get: function get$1() {
      return 'vaadin.statistics.optout';
    }
  }]);
  return UsageStatistics;
}();

try {
  window.Vaadin = window.Vaadin || {};
  window.Vaadin.usageStatsChecker = window.Vaadin.usageStatsChecker || new UsageStatistics();
  window.Vaadin.usageStatsChecker.maybeGatherAndSend();
} catch (e) {
  // Intentionally ignored as this is not a problem in the app being developed
}

}());

  vaadin-dev-mode:end **/ }
const $f9d9d110dea7aeee$var$usageStatistics = function() {
    if (typeof $f9d9d110dea7aeee$var$runIfDevelopmentMode === "function") return $f9d9d110dea7aeee$var$runIfDevelopmentMode($f9d9d110dea7aeee$var$maybeGatherAndSendStats);
};
window.Vaadin = window.Vaadin || {};
window.Vaadin.registrations = window.Vaadin.registrations || [];
window.Vaadin.registrations.push({
    is: "@vaadin/router",
    version: "1.7.4"
});
$f9d9d110dea7aeee$var$usageStatistics();
$f9d9d110dea7aeee$export$55185c17a0fcbe46.NavigationTrigger = {
    POPSTATE: $f9d9d110dea7aeee$var$POPSTATE,
    CLICK: $f9d9d110dea7aeee$var$CLICK
};


/* Variables */ const $e7453e1bf0e39a4e$var$style = document.createElement("style");
var $f535c099c9126121$exports = {};
$f535c099c9126121$exports = new URL("prequir\xfargico.044d6275.pdf", import.meta.url).toString();


var $ce17c60c061cde41$exports = {};
$ce17c60c061cde41$exports = new URL("logo-sprc.382ec9bd.png", import.meta.url).toString();


/* Rutas de navegación */ const $e7453e1bf0e39a4e$var$NAV_ROUTES = [
    [
        ".logo",
        "/"
    ],
    [
        ".institucional",
        "/nosotros"
    ],
    [
        ".trabaja",
        "/trabaja"
    ],
    [
        ".cobertura",
        "/cobertura"
    ],
    [
        ".horarios",
        "/horarios"
    ],
    [
        ".profesionales",
        "/profesionales"
    ],
    [
        ".diagnostico",
        "/diagnostico"
    ],
    [
        ".laboratorio",
        "/laboratorio"
    ],
    [
        ".cardiologia",
        "/cardiologia"
    ],
    [
        ".sedes",
        "/sedes"
    ]
];
class $e7453e1bf0e39a4e$export$5be6d1e4b3a88225 extends HTMLElement {
    connectedCallback() {
        this.render();
        $e7453e1bf0e39a4e$var$NAV_ROUTES.forEach(([selector, path])=>{
            this.querySelector(selector)?.addEventListener("click", ()=>(0, $f9d9d110dea7aeee$export$55185c17a0fcbe46).go(path));
        });
    }
    render() {
        this.className = "header";
        this.innerHTML = `
        <!-- Header -->
        <div class="header-container">
            <div class="header-box">
            <div class="header__logo-box">
                <img src="${$ce17c60c061cde41$exports}" class="header__logo logo">
            </div>

            <div class="header__info">
                <div class="header__link-box">
                <a class="header__call-number" href="https://portal.sprc.com.ar/pacientes/" target="_blank">Portal del Paciente</a>
                <a class="header__entrega-digital" href="https://sanatorioprivado.com.ar/imagenes/" target="_blank">Entrega Digital</a>
                </div>
            </div>

            </div>
        </div>
        <!-- Nav -->
        <div class="nav-container">
            <div class="nav-box">
            <div class="nav__nosotros-box">
                <button class="nav__menu nosotros">NOSOTROS</button>
                <div class="nav__nosotros-content">
                <button class="nav__nosotros institucional">Institucional</button>
                <button class="nav__nosotros trabaja">Trabaja con Nosotros</button>
                </div>
            </div>
            <div class="nav__pacientes-box">
                <button class="nav__menu pacientes">PACIENTES</button>
                <div class="nav__pacientes-content">
                <button class="nav__pacientes cobertura">Cobertura M\xe9dica</button>
                <button class="nav__pacientes horarios">Horarios</button>
                <a class="nav__pacientes internacion" href="${$f535c099c9126121$exports}" download="">Informaci\xf3n para Internaci\xf3n</a>
                </div>
            </div>
            <div class="nav__servicios-box">
                <button class="nav__menu servicios">SERVICIOS</button>
                <div class="nav__servicios-content">
                <button class="nav__servicios profesionales">Profesionales</button>
                <button class="nav__servicios diagnostico">Diagn\xf3stico por Im\xe1genes</button>
                <button class="nav__servicios laboratorio">Laboratorio de An\xe1lisis Cl\xednicos y Microbiol\xf3gicos</button>
                <button class="nav__servicios cardiologia">Cardiolog\xeda</button>
                <button class="nav__servicios sedes">Sedes y Centros Asociados</button>
                </div>
            </div>
            <div class="nav__intranet-box">
                <button class="nav__menu intranet">INTRANET</button>
                <div class="nav__intranet-content">
                <a class="nav__intranet" href="http://sistema.sanatorioprivado.com.ar:10500/sistema/" target="_blank">Sistema</a>
                <a class="nav__intranet" href="http://webmail.sanatorioprivado.com.ar/" target="_blank">Webmail</a>
                <a class="nav__intranet" href="https://imagenes.sprc.com.ar/" target="_blank">Portal Im\xe1genes</a>
                <a class="nav__intranet" href="https://misrx.com.ar/login" target="_blank">Recetas MisRx</a>
                <a class="nav__intranet" href="https://aplicaciones.cmpc.org.ar/menu/" target="_blank">Recetas Consejo M\xe9dico</a>
                <a class="nav__intranet" href="https://www.farmalink.com.ar/customlogin/login.jsp" target="_blank">Recetas FarmaLink</a>
                </div>
            </div>
            </div>
        </div>
        `;
        $e7453e1bf0e39a4e$var$style.innerHTML = `
        /* Header */
        .header-container{
            font-family: 'Poppins', sans-serif;
            height: 100px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
        }
        .header-box{
            width: 1024px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 20px;
        }
        .logo{
            height: 70px;
            cursor: pointer;
        }
        .header__link-box{
            display: flex;
            flex-direction: column;
        }
        .header__call-number{
            margin: 0 auto;
            width: 250px;
            text-align: center;
            background-color: #50af70;
            color: whitesmoke;
            border-radius: 10px;
            font-size: 24px;
            text-decoration: none;
        }
        .header__entrega-digital{
            margin: 8px auto 0;
            width: 250px;
            text-align: center;
            background-color: #1e88e5;
            color: whitesmoke;
            border-radius: 10px;
            font-size: 24px;
            text-decoration: none;
        }

        /* Nav */
        .nav-container{
            height: 50px;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            background-color: whitesmoke;
        }
        .nav-box{
            width: 768px;
            display: grid;
            grid-template-columns: 25% 25% 25% 25%;
            justify-content: center;
        }
        .nav__menu{
            border: none;
            height: 50px;
            width: 150px;
            background-color: transparent;
            color: #1e1e1ead;
            text-align: center;
            font-size: 15px;
            cursor: pointer;
        }
        .nav__nosotros-box,
        .nav__pacientes-box,
        .nav__servicios-box,
        .nav__intranet-box{
            position: relative;
            display: inline-block;
        }
        .nav__nosotros-content,
        .nav__pacientes-content,
        .nav__servicios-content,
        .nav__intranet-content{
            display: none;
            position: absolute;
            background-color: #f1f1f1;
            min-width: 260px;
            box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
            z-index: 1;
        }
        .nav__nosotros,
        .nav__pacientes,
        .nav__servicios,
        .nav__intranet{
            border: none;
            min-height: 50px;
            min-width: 260px;
            background-color: transparent;
            color: rgba(0, 0, 0, 0.60);
            text-align: start;
            font-size: 15px;
            padding: 12px 16px;
            cursor: pointer;
        }
        .nav__nosotros-content a,
        .nav__pacientes-content a,
        .nav__servicios-content a,
        .nav__intranet-content a{
            color: rgba(0, 0, 0, 0.60);
            padding: 12px 16px;
            text-decoration: none;
            display: block;
        }
        .nosotros:hover,
        .nav__nosotros:hover,
        .pacientes:hover,
        .nav__pacientes:hover,
        .servicios:hover,
        .nav__servicios:hover,
        .intranet:hover,
        .nav__intranet:hover{
            transition: 0.5s;
            background-color: #ddd;
        }
        .nav__nosotros-box:hover .nav__nosotros-content,
        .nav__pacientes-box:hover .nav__pacientes-content,
        .nav__servicios-box:hover .nav__servicios-content,
        .nav__intranet-box:hover .nav__intranet-content{
            transition: 0.5s;
            display: block;
        }
        `;
        this.appendChild($e7453e1bf0e39a4e$var$style);
    }
}
/* Define */ customElements.define("header-components", $e7453e1bf0e39a4e$export$5be6d1e4b3a88225);


/* Variables */ const $791dbe1805b7a1bf$var$style = document.createElement("style");
var $7b03f4dbb4d7b5f5$exports = {};
$7b03f4dbb4d7b5f5$exports = new URL("icon-whatsapp.6331bf9a.png", import.meta.url).toString();


var $e09e19849f6e3b79$exports = {};
$e09e19849f6e3b79$exports = new URL("icon-linkedin.b818e2b3.png", import.meta.url).toString();


var $6462e6b5cab8b45b$exports = {};
$6462e6b5cab8b45b$exports = new URL("icon-instagram.2e128d1f.png", import.meta.url).toString();


var $e3fbcf0844ee80af$exports = {};
$e3fbcf0844ee80af$exports = new URL("icon-facebook.2bd313d5.png", import.meta.url).toString();


class $791dbe1805b7a1bf$export$189e3f0ab56ac948 extends HTMLElement {
    /* Connected to CallBack */ connectedCallback() {
        this.render();
    }
    /* Render */ render() {
        this.className = "footer";
        this.innerHTML = `
        <!-- Footer -->
        <div class="footer">
            <div class="footer-box">
                <div class="footer__sucursales">
                    <h4 class="footer__sucursales-title">Sedes y Centros Asociados</h4>
                    <a href="/sedes">Sanatorio Privado Rio Cuarto</a>
                    <a href="/sedes">Bio Centro M\xe9dico</a>
                    <a href="/sedes">Resonancia Magnetica Rio Cuarto</a>
                </div>
                <div class="footer__informacion">
                    <h4  class="footer__informacion-title">Contacto</h4>
                    <!-- <a href="/">Dejanos un mensaje</a> -->
                    <a href="/">\xbfDonde nos encontramos?</a>
                    <a href="#">Ir al inicio</a>
                </div>
                <div class="footer__redes">
                    <h4 class="footer__redes-title">Redes Sociales</h4>
                    <div class="footer__redes-icon">
                        <a href="https://es-la.facebook.com/sanatorioprivadoderiocuarto/"><img src="${$e3fbcf0844ee80af$exports}" alt="facebook" class="footer__redes-img"></a>
                        <a href="https://www.linkedin.com/company/sanatorioprivado-rio-cuarto/"><img src="${$e09e19849f6e3b79$exports}" alt="linkedin" class="footer__redes-img"></a>
                        <a href="https://instagram.com/sanatorioprivadoriocuarto/"><img src="${$6462e6b5cab8b45b$exports}" alt="instagram" class="footer__redes-img"></a>
                        <a href="https://api.whatsapp.com/send?phone=543584675800&text&source&data&app_absent&lang=es"><img src="${$7b03f4dbb4d7b5f5$exports}" alt="whatsapp" class="footer__redes-img"></a>
                    </div>
                </div>
            </div>
            <div class="footer__desing">
                <h6 class="footer__desing-info">Sanatorio Privado 2025 \xa9</h6>
            </div>
        </div>
        `;
        $791dbe1805b7a1bf$var$style.innerHTML = `
        /* Footer */
        .footer{
            font-family: 'Poppins', sans-serif;
            width: 100%;
            min-height: 250px;
            background-color: #50af70;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            gap: 15px;
        }
        /* Footer - Box */
        .footer-box{
            width: 1024px;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
        }
        .footer__sucursales,
        .footer__informacion,
        .footer__redes{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .footer__sucursales-title,
        .footer__informacion-title,
        .footer__redes-title{
            font-size: 18px;
            color: whitesmoke
        }
        .footer__sucursales a,
        .footer__informacion a{
            font-size: 15px;
            color: rgba(245, 245, 245, 0.72);
            padding: 3px;
            text-decoration: none;
        }
        .footer__redes-icon{
            display: flex;
            gap: 10px;
        }
        .footer__redes-img{
            height: 35px;
            width: 35px;
        }
        `;
        this.appendChild($791dbe1805b7a1bf$var$style);
    }
}
/* Define */ customElements.define("footer-components", $791dbe1805b7a1bf$export$189e3f0ab56ac948);


/* Class No Page */ class $471d51884eb22c52$export$946db6ee7f326c6d extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "no-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo no-page__cuerpo">
                        <div class="no-page__text">
                            <h3 class="body__cuerpo-text-title">Sitio en construcci\xf3n.</h3>
                            <h3 class="body__cuerpo-text-subtitle">Pr\xf3ximamente m\xe1s informaci\xf3n.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("no-page", $471d51884eb22c52$export$946db6ee7f326c6d);


/* Contentful */ const $0b89d474933103bc$var$CONTENTFUL_URL = "https://cdn.contentful.com/spaces/vzrchh5059a8/environments/master/entries?access_token=rycvlQrg1NFTKqUz7jfatycdJ9nuFrsxh8LlfViD9so";
function $0b89d474933103bc$var$fetchContentful(contentType) {
    return fetch(`${$0b89d474933103bc$var$CONTENTFUL_URL}&content_type=${contentType}`).then((r)=>r.json());
}
/* State */ const $0b89d474933103bc$export$ca000e230c0caa3e = {
    /* Template - Foto */ searchImagen (idPhoto, data) {
        return data.includes.Asset.find((item)=>item.sys.id === idPhoto);
    },
    /* Welcome */ addNotice (params) {
        const template = document.querySelector(".noticias__template");
        const container = document.querySelector(".body__noticias");
        template.content.querySelector(".noticias__title").textContent = params.titulo;
        template.content.querySelector(".noticias__subtitle").textContent = params.informacion;
        template.content.querySelector(".noticias__photo").src = params.foto;
        container.appendChild(document.importNode(template.content, true));
    },
    dataWelcome () {
        $0b89d474933103bc$var$fetchContentful("home").then((data)=>{
            data.items.forEach((item)=>{
                this.addNotice({
                    titulo: item.fields.titulo,
                    informacion: item.fields.informacion,
                    foto: this.searchImagen(item.fields.foto.sys.id, data).fields.file.url
                });
            });
        });
    },
    /* Trabaja */ addJob (params) {
        const template = document.querySelector(".job__template");
        const container = document.querySelector(".job__container");
        template.content.querySelector(".job__titulo").textContent = params.puesto;
        template.content.querySelector(".job__descripcion").textContent = params.descripcion;
        template.content.querySelector(".job__disponibilidad").textContent = params.disponibilidad;
        container.appendChild(document.importNode(template.content, true));
    },
    dataJob () {
        $0b89d474933103bc$var$fetchContentful("busquedas").then((data)=>{
            data.items.forEach((item)=>{
                this.addJob({
                    puesto: item.fields.puesto,
                    descripcion: item.fields.descripcion,
                    disponibilidad: item.fields.disponibilidad
                });
            });
        });
    },
    /* Sedes */ addSedes (params) {
        const template = document.querySelector(".sedes__template");
        const container = document.querySelector(".sedes__container");
        template.content.querySelector(".sedes__titulo").textContent = params.periferico;
        template.content.querySelector(".sedes__direccion").textContent = params.direccion;
        template.content.querySelector(".sedes__phone").textContent = params.telefono;
        template.content.querySelector(".sedes__mail").textContent = params.contacto;
        template.content.querySelector(".sedes__photo").src = params.foto;
        container.appendChild(document.importNode(template.content, true));
    },
    dataSedes () {
        $0b89d474933103bc$var$fetchContentful("sucursales").then((data)=>{
            data.items.forEach((item)=>{
                this.addSedes({
                    periferico: item.fields.periferico,
                    direccion: item.fields.direccion,
                    telefono: item.fields.telefono,
                    contacto: item.fields.contacto,
                    foto: this.searchImagen(item.fields.foto.sys.id, data).fields.file.url
                });
            });
        });
    },
    /* Profesionales */ addProfesionales (params) {
        const template = document.querySelector(".profesional__template");
        const container = document.querySelector(".body__profesionales-container");
        template.content.querySelector(".profesional__especialidad").textContent = params.Especialidad;
        template.content.querySelector(".profesional__info").textContent = params.Profesional;
        container.appendChild(document.importNode(template.content, true));
    },
    dataProfesionales (data) {
        data.forEach((i)=>this.addProfesionales(i));
    },
    /* Mutuales */ addMutuales (mutual) {
        const template = document.querySelector(".mutuales__template");
        const container = document.querySelector(".body__mutuales-container");
        template.content.querySelector(".mutuales__info").textContent = mutual;
        container.appendChild(document.importNode(template.content, true));
    },
    dataMutuales (data) {
        data.forEach((mutual)=>this.addMutuales(mutual));
    }
};


/* Variables */ const $4ffce5fddec20c53$var$style = document.createElement("style");
var $631797246cffc84a$exports = {};
$631797246cffc84a$exports = new URL("home.c295c359.webm", import.meta.url).toString();


var $5a9ae98057d2592b$exports = {};
$5a9ae98057d2592b$exports = new URL("home.b6d65731.mp4", import.meta.url).toString();



class $4ffce5fddec20c53$export$630ad10f0e1a953d extends HTMLElement {
    connectedCallback() {
        this.render();
        (0, $0b89d474933103bc$export$ca000e230c0caa3e).dataWelcome();
    }
    render() {
        this.className = "welcome-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body" style="flex-direction:column;">
                <!-- Hero -->
                <video class="wallpaper" autoplay loop muted playsinline>
                    <source src="${$631797246cffc84a$exports}" type="video/webm">
                    <source src="${$5a9ae98057d2592b$exports}" type="video/mp4">
                </video>

                <div class="body-box">
                    <div class="body__break"></div>

                    <div class="body__wa">
                        <p>Agenda tu turno al </p>
                        <h3>+549 358 4675800</h3>
                        <p>\xf3</p>
                        <a href="https://wa.me/5493584675800" class="formulario" target="_blank">
                            <img src="${$7b03f4dbb4d7b5f5$exports}" alt="whatsapp" class="formulario__icon">
                            Escribinos
                        </a>
                    </div>

                    <div class="body__break"></div>

                    <div class="body__ubicacion">
                        <div class="body__cuerpo-text">
                            <h3 class="body__cuerpo-text-title">Sede Central</h3>
                            <h5 class="body__cuerpo-text-subtitle right">Direcci\xf3n: Bv. Roca 949 - Rio Cuarto <br> Lineas Rotativas: +549 358 4675800 <br> Contacto: info@sanatorioprivado.com.ar</h5>
                        </div>
                        <div class="body__cuerpo-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13364.847665217008!2d-64.3399908!3d-33.1297968!3m2!1i1024!2i768!4f3!3m3!1m2!1s0x95d20007b4855555%3A0x148336ad0c4d8c8b!2sPrestaciones%20Integrales%20Medicas%20Sa!5e0!3m2!1ses!2sar!4v1699966049624!5m2!1ses!2sar" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>

                    <div class="body__break"></div>
                </div>
            </div>
        </div>
        `;
        $4ffce5fddec20c53$var$style.innerHTML = `
        .wallpaper{
            height: 500px;
            width: 100%;
            object-fit: cover;
            background-color: #1E1E1E75;
        }
        .body__break{
            height: 35px;
        }
        .body__noticias{
            background-color: #1e1e1e10;
            min-height: 300px;
            width: 100%;
            display: grid;
            grid-template-columns: 33% 33% 33%;
            justify-content: center;
            padding: 25px;
            gap: 10px;
        }
        .body__wa{
            background-color: #1e1e1e10;
            min-height: 100px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 23px;
            gap: 20px;
        }
        .formulario{
            display: flex;
            align-items: center;
            gap: 10px;
            background-color: whitesmoke;
            color: #1e1e1e;
            border-radius: 50px;
            font-size: 20px;
            font-weight: 500;
            text-decoration: none;
            padding: 10px 22px;
            transition: background-color 0.3s, transform 0.2s;
        }
        .formulario:hover{
            background-color: #ffffff;
            transform: scale(1.05);
        }
        .formulario__icon{
            height: 28px;
            width: 28px;
        }
        .noticias{
            display: flex;
            flex-direction: column;
            min-height: 250px;
            align-items: center;
            gap: 20px;
        }
        .noticias__title{
            margin: 0 auto;
            font-size: 25px;
            text-align: center;
        }
        .noticias__subtitle{
            font-size: 15px;
        }
        .noticias__photo{
            height: 200px;
            width: 100%;
            background-color: #1E1E1E75;
        }
        .body__ubicacion{
            background-color: #1e1e1e10;
            height: 300px;
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            gap: 20px;
        }
        .body__cuerpo-map{
            height: 300px;
            width: 60%;
        }
        `;
        this.appendChild($4ffce5fddec20c53$var$style);
    }
}
/* Define */ customElements.define("welcome-page", $4ffce5fddec20c53$export$630ad10f0e1a953d);


/* Class Nosotros */ class $018a8573d9cd844e$export$62a00a4317cce231 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "nosotros-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">\xa1Comprometidos con tu salud!</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">Desde nuestra fundaci\xf3n en el a\xf1o 2000, en Sanatorio Privado R\xedo Cuarto nos hemos dedicado apasionadamente a proporcionar servicios m\xe9dicos de alta calidad para la ciudad y la regi\xf3n. Ubicados estrat\xe9gicamente en el Boulevard Roca 949 de la ciudad de R\xedo Cuarto, nos enorgullece ser un pilar en el cuidado de la salud de nuestra comunidad.<br> Servicios Integralmente Dise\xf1ados:<br>Ofrecemos una amplia gama de servicios m\xe9dicos para abordar todas las necesidades de salud de nuestros pacientes. Desde atenci\xf3n ambulatoria en consultorios hasta servicios especializados, nuestra instituci\xf3n est\xe1 comprometida con la excelencia m\xe9dica.<br> Infraestructura Moderna y Equipamiento Avanzado:<br>Contamos con instalaciones modernas y equipamiento de \xfaltima generaci\xf3n para brindar servicios de calidad. Nuestro sanatorio alberga un laboratorio de an\xe1lisis bioqu\xedmicos y microbiolog\xeda, servicios de diagn\xf3stico por im\xe1genes y una guardia central para adultos, garantizando respuestas r\xe1pidas y precisas a las necesidades de nuestros pacientes.<br> Internaci\xf3n y Cuidados Especializados:<br>Para aquellos que requieren internaci\xf3n, nuestro sanatorio ofrece habitaciones confortables con ba\xf1o privado. Adem\xe1s, contamos con una Unidad de Terapia Intensiva para adultos y un \xe1rea especializada en cirug\xeda e intervencionismo que incluye quir\xf3fanos, salas de endoscopia y servicios de hemodinamia.<br>Comprometidos con su Bienestar:<br>En Sanatorio Privado R\xedo Cuarto, la atenci\xf3n centrada en el paciente es nuestra prioridad. Nuestro equipo de profesionales altamente calificados y comprometidos est\xe1 aqu\xed para brindarle la mejor atenci\xf3n m\xe9dica posible, asegurando su bienestar y tranquilidad.<br>Explore nuestras instalaciones, conozca a nuestro equipo y descubra c\xf3mo en Sanatorio Privado R\xedo Cuarto, la salud y el cuidado van de la mano. Estamos aqu\xed para usted, comprometidos con su salud y calidad de vida.</h5>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("nosotros-page", $018a8573d9cd844e$export$62a00a4317cce231);



class $afed6b31e36da77f$export$b3b02af00211cbb8 extends HTMLElement {
    connectedCallback() {
        this.render();
        (0, $0b89d474933103bc$export$ca000e230c0caa3e).dataSedes();
    }
    render() {
        this.className = "sedes-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo sedes__info">
                        <div class="sedes__info-text">
                            <h3 class="body__cuerpo-text-title">Sedes y Centro Asociados</h3>
                        </div>
                    </div>
                    <div class="body__cuerpo">
                        <div class="sedes__container">
                            <template class="sedes__template">
                                <div class="sedes__box">
                                    <img class="sedes__photo" src="" alt="sede">
                                    <h2 class="sedes__titulo">Data</h2>
                                    <p class="sedes__direccion">Data</p>
                                    <p class="sedes__phone">Data</p>
                                    <p class="sedes__mail">Data</p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("sedes-page", $afed6b31e36da77f$export$b3b02af00211cbb8);



const $8ff575a4ccc1ade5$export$4051a07651545597 = [
    "ABOGADOS",
    "AMPROSA",
    "AMSTERDAM SALUD",
    "APROSS",
    "ASOCIART SA ART",
    "ASPURC",
    "ATSA - OSPSA",
    "AVALIAN",
    "BERKLEY ART",
    "CAJA NOTARIAL",
    "CARMED",
    "CIENCIAS ECONOMICAS",
    "ENDOCTER - ENSALUD",
    "ENSALUD",
    "EXPERTA ART (EX QBE)",
    "FEDERADA SALUD",
    "FUTBOLISTAS AGREMIADOS",
    "GALENO - AZUL Y BLANCO",
    "GALENO - ORO Y PLATA",
    "GENMED MEDICAL ASISTANCE",
    "GRAFICOS",
    "IOSFA - DIBA",
    "ISSPICA",
    "JERARQUICO SALUD",
    "LA SEGUNDA ART",
    "LABOUMED SRL",
    "LUIS PASTEURS",
    "LUZ Y FUERZA (AESA) ALUMBRAR",
    "LUZ Y FUERZA REGIONAL SALUD",
    "MADEREROS",
    "MEDICUS - AZUL - BLANCO - CELESTE",
    "MEDICUS - CORP - FAMILY - MC",
    "MEDINALS - PREMED",
    "MUNICIPALES",
    "MUTUAL MEDICA",
    "NOBIS",
    "OMINT SA",
    "OPDEA",
    "OSADEF (EMPLEADOS DE FARMACIA)",
    "OSAM - MINEROS",
    "OSAPM (PROPAGANDA MEDICA)",
    "OSDE",
    "OSDOP - SERVIRED",
    "OSFATLYF RIO CUARTO",
    "OSFATLYF VILLA MARIA",
    "OSFATUN NO DOCENTE",
    "OSOETSYLRA - TINTOREROS (ENSALUD)",
    "OSPACA",
    "OSPCRA (ENSALUD)",
    "OSPECOR",
    "OSPEDYC",
    "OSPEP (PANADEROS)",
    "OSPERHYRA",
    "OSPES (ESTACIONES DE SERVICIO)",
    "OSPIHMP (HIELO) ENSALUD",
    "OSPIM (ENSALUD)",
    "OSSACRA",
    "OSTEL - ACTIVOS - ENSALUD",
    "OSTEL - JUBILADOS - ENSALUD",
    "PARQUE SALUD",
    "PASTELEROS (OPCPHYA)",
    "PODER JUDICIAL",
    "POLICIA FEDERAL",
    "PRENSA",
    "PREVENCION SALUD",
    "PRIVEL OBRA SOCIAL",
    "PRIVEL SERVICIOS SOCIALES",
    "SADAIC",
    "SAN PEDRO",
    "SANCOR SALUD",
    "SAT (TV SALUD)",
    "SEGUROS",
    "SERVIRED (OSBLYCA)",
    "SWISS MEDICAL",
    "UNIMED",
    "UTA"
];


class $91362b5270957ac7$export$8b8a26bb822ac057 extends HTMLElement {
    connectedCallback() {
        this.render();
        (0, $0b89d474933103bc$export$ca000e230c0caa3e).dataMutuales((0, $8ff575a4ccc1ade5$export$4051a07651545597));
    }
    render() {
        this.className = "cobertura-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">

                    <div class="body__cuerpo cobertura__info">
                        <div class="cobertura__text">
                            <h3 class="body__cuerpo-text-title">Obras Sociales</h3>
                            <h5 class="body__cuerpo-text-subtitle">El Sanatorio Privado R\xedo Cuarto atiende a las siguientes obras sociales y prepagas. Para conocer las modalidades de atenci\xf3n de la cobertura m\xe9dica que poseas, deber\xe1s consultar a la misma d\xf3nde te informar\xe1n las condiciones para atenderte en nuestra Instituci\xf3n.</h5>
                        </div>
                    </div>

                    <div class="body__mutuales-container">
                        <template class="mutuales__template">
                            <div class="mutuales__container">
                                <h3 class="mutuales__info">Mutual</h3>
                            </div>
                        </template>
                    </div>

                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("cobertura-page", $91362b5270957ac7$export$8b8a26bb822ac057);


/* Class Horarios */ class $44d926c2d64e01e6$export$325b069b0e185f71 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "horarios-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">

                    <div class="body__cuerpo">
                        <div class="horarios__text up">
                            <h3 class="body__cuerpo-text-title horarios__title">Horarios de atenci\xf3n, visita y acompa\xf1antes</h3>
                        </div>
                    </div>

                    <div class="body__cuerpo">
                        <div class="horarios__text">
                            <h3 class="body__cuerpo-text-title"> \u{2022} Guardia y Emergencias</h3>
                            <h4 class="body__cuerpo-text-subtitle">Para la atenci\xf3n por Guardia M\xe9dica traer Documento de Identidad y Credencial de la Cobertura M\xe9dica.<br> Ingreso por Sargento Cabral 1064</h4>
                        </div>
                    </div>

                    <div class="body__cuerpo">
                        <div class="horarios__text">
                            <h3 class="body__cuerpo-text-title"> \u{2022} Horarios de Atenci\xf3n</h3>
                            <h4 class="body__cuerpo-text-title">Recepci\xf3n / Administraci\xf3n</h4>
                            <h5 class="body__cuerpo-text-subtitle">Lunes a Viernes de 8:00 a 12:00 hs  \u{2013} 16:00 a 20:00 hs.</h5>
                        </div>
                    </div>

                    <div class="body__cuerpo">
                        <div class="horarios__text">
                            <h3 class="body__cuerpo-text-title"> \u{2022} Diagn\xf3stico por Im\xe1genes</h3>
                            <h4 class="body__cuerpo-text-title">Horarios de atenci\xf3n</h4>
                            <h5 class="body__cuerpo-text-subtitle">Lunes a Viernes de 8:00 a 20:00 hs.</h5>
                        </div>
                    </div>

                    <div class="body__cuerpo">
                        <div class="horarios__text">
                            <h3 class="body__cuerpo-text-title"> \u{2022} Laboratorio de An\xe1lisis Cl\xednicos</h3>
                            <h4 class="body__cuerpo-text-title">Horarios de atenci\xf3n</h4>
                            <h5 class="body__cuerpo-text-subtitle">Lunes a Viernes de 7:30 a 12:00 hs \u{2013} 16:00 a 20:00 hs.</h5>
                            <h4 class="body__cuerpo-text-title">Horarios de extracci\xf3n</h4>
                            <h5 class="body__cuerpo-text-subtitle">Lunes a Viernes de 8:00 a 20:00 hs.</h5>
                            <h4 class="body__cuerpo-text-title">Horarios de entrega de resultados</h4>
                            <h5 class="body__cuerpo-text-subtitle">Lunes a Viernes de 10:00 a 12:00 hs - 16:00 a 19:30 hs.</h5>
                        </div>
                    </div>

                    <div class="body__cuerpo">
                        <div class="horarios__text">
                            <h3 class="body__cuerpo-text-title"> \u{2022} Horario de Visitas</h3>
                            <h5 class="body__cuerpo-text-subtitle">El Sanatorio Privado R\xedo Cuarto implementa normas/pol\xedticas que regulan las visitas y el acompa\xf1amiento de los pacientes que permanecen internados en la instituci\xf3n, permitiendo la permanencia de acompa\xf1antes definiendo horarios de visita en cada sector, siempre sujetos a las necesidades tanto del paciente como del sector en el cual se encuentre internado.<br> Se transmite a la familia del paciente la informaci\xf3n acerca de los horarios de visita correspondientes al sector mediante folletos, carteles informativos o verbalmente por parte del equipo tratante.<br> El r\xe9gimen y el horario definido seg\xfan el \xe1rea de internaci\xf3n ser\xe1n los siguientes: </h5>
                            <h4 class="body__cuerpo-text-title">Informe M\xe9dico:</h4>
                            <h5 class="body__cuerpo-text-subtitle">Terapia: 12:00 a 13:00 hs <br> Piso: 8:00 a 12:00 hs - Se le comunica al acompa\xf1ante</h5>
                            <h4 class="body__cuerpo-text-title">Visitas:</h4>
                            <h5 class="body__cuerpo-text-subtitle">Piso: 17:00 a 19:00 hs</h5>
                            <h5 class="body__cuerpo-text-subtitle">Acompa\xf1antes: solo 1 (una) por persona a la vez. En el caso de habitaciones compartidas, el acompa\xf1ante debe ser del mismo sexo que el paciente.<br> El cambio de acompa\xf1antes se deber\xe1 realizar en la sala de espera, no as\xed en zona de tr\xe1nsito de pacientes (pasillos). <br> Se solicita el retiro del acompa\xf1ante ante la realizaci\xf3n de un procedimiento o una situaci\xf3n de emergencia en el \xe1rea.</h5>
                            <h4 class="body__cuerpo-text-title">Alimentaci\xf3n</h4>
                            <h5 class="body__cuerpo-text-subtitle">Desayuno: 8:00 a 9:00 hs <br>Almuerzo: 12:00 a 13:00 hs <br>Merienda: 16:00 a 17:00 hs <br>Cena: 20:00 a 21:00 hs</h5>
                            <h4 class="body__cuerpo-text-title">Servicio de Limpieza de Habitaciones:</h4>
                            <h5 class="body__cuerpo-text-subtitle">Turno Ma\xf1ana: 6:30 a 9:30 hs <br>Turno Tarde: 14:30 a 17:00 hs</h5>
                            <h5 class="body__cuerpo-text-subtitle">Aclaraci\xf3n: Fuera del horario establecido, se podr\xe1 solicitar el servicio, informando en sector cocina.<br> Por favor tenga en cuenta que, por pol\xedticas del Sanatorio, no est\xe1 permitido fumar dentro de la instituci\xf3n y se proh\xedbe el ingreso de animales, armas de cualquier tipo, flores, equipo de mate, reposeras, etc.</h5>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("horarios-page", $44d926c2d64e01e6$export$325b069b0e185f71);



class $6bb7f8dcb263d6a9$export$a995d7aa648f17cc extends HTMLElement {
    connectedCallback() {
        this.render();
        (0, $0b89d474933103bc$export$ca000e230c0caa3e).dataJob();
    }
    render() {
        this.className = "trabaja-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo trabaja__header">
                        <div class="trabaja__header-text">
                            <h3 class="body__cuerpo-text-title">\xa1Estas son nuestras b\xfasquedas activas!</h3>
                            <a class="formulario__cv" href="https://forms.gle/1yDoAo8U9ZGRntNX8">Carga tu CV</a>
                        </div>
                    </div>
                    <div class="body__cuerpo">
                        <div class="job__container">
                            <template class="job__template">
                                <div class="job__box">
                                    <h2 class="job__titulo">Puesto Solicitado</h2>
                                    <div class="job__etiquetas">
                                        <h2 class="job__disponibilidad">Disponibilidad</h2>
                                    </div>
                                    <p class="job__descripcion">Descripcion del puesto buscado.</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="body__cuerpo trabaja__footer">
                        <div class="trabaja__enviar">
                            <h3 class="enviar">\xbfD\xf3nde puedo enviar mi CV?</h3>
                            <h5 class="enviar-info">Para enviar CV, hacerlo a seleccion@sanatorioprivado.com.ar e indicar el puesto de inter\xe9s en el asunto del mail.</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
}
/* Define */ customElements.define("trabaja-page", $6bb7f8dcb263d6a9$export$a995d7aa648f17cc);


/* Variables */ const $f9b38f7fd0fbf448$var$style = document.createElement("style");
var $cb5bd9118782b6aa$exports = {};
$cb5bd9118782b6aa$exports = new URL("diag2.37361f0f.webp", import.meta.url).toString();


var $7570f44800539988$exports = {};
$7570f44800539988$exports = new URL("diag1.43029a0e.webp", import.meta.url).toString();


class $f9b38f7fd0fbf448$export$95d338a3ea00042b extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "diagnostico-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo diagnostico__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">Diagn\xf3stico por Im\xe1genes</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">En nuestro centro, contamos con una variedad de tecnolog\xedas y especialidades para brindarle un diagn\xf3stico preciso y confiable.<br>Nuestro equipo de expertos en diagn\xf3stico por im\xe1genes trabajar\xe1 en estrecha colaboraci\xf3n con usted y su m\xe9dico para comprender sus necesidades y brindarle un cuidado personalizado. En nuestro departamento, encontrar\xe1 servicios tales como Tomograf\xeda Computada, Radiolog\xeda General, Digestiva, Mastol\xf3gica e Intervencionista, Mamograf\xeda y Ecograf\xeda.<br>La Tomograf\xeda Computada es una herramienta avanzada que nos permite obtener im\xe1genes detalladas de su cuerpo, ayudando a identificar y evaluar diversas afecciones m\xe9dicas. Nuestra radiolog\xeda general est\xe1 equipada con tecnolog\xeda de \xfaltima generaci\xf3n para obtener im\xe1genes precisas de diferentes partes del cuerpo, ofreciendo un diagn\xf3stico completo.<br>Adem\xe1s, contamos con especialidades espec\xedficas, como la radiolog\xeda digestiva, que nos permite visualizar y evaluar el sistema gastrointestinal, y la radiolog\xeda mastol\xf3gica e intervencionista, que se centra en el diagn\xf3stico y tratamiento de enfermedades de las mamas.<br>No podemos olvidar la importancia de la mamograf\xeda en el diagn\xf3stico temprano del c\xe1ncer de mama. Nuestro departamento est\xe1 equipado con la \xfaltima tecnolog\xeda en mamograf\xeda, brindando un examen r\xe1pido y preciso para la detecci\xf3n temprana de esta enfermedad.<br>Por \xfaltimo, pero no menos importante, nuestra ecograf\xeda es una herramienta segura y eficaz para evaluar diferentes partes del cuerpo. Proporciona im\xe1genes en tiempo real que nos permiten detectar y diagnosticar diversas afecciones con precisi\xf3n.<br><br>\u{2022} Jefe de Servicio<br>Dr. Vettorazzi Rom\xe1n - M.P. 26.009/3<br><br>\u{2022} Profesionales M\xe9dicos<br>Dr. Di Giorgio Roberto - M.P. 16.733<br>Dra. Dodero Mar\xeda de los \xc1ngeles - M.P. 34.596<br>Dr. Selak Franco - M.P. 34.027/2<br>Dr. Balerdi Rodolfo - M.P. 23.443<br><br>\u{2022} Licenciados en Diagn\xf3stico en Bio Im\xe1genes<br>Lic. Basualdo Jos\xe9<br>Lic. Escudero Evangelina<br>Lic. Ferreyra Pablo<br>Lic. Gallardo Martin<br>Lic. Perez Marina<br>Lic. Requelme Noelia</h5>
                            <h5 class="body__cuerpo-text-subtitle">\u{2022} Contacto:</h5>
                            <div class="service-actions">
                                <a class="service-btn" href="/horarios">Horarios</a>
                                <a class="service-btn" href="https://api.whatsapp.com/send?phone=543585610243&text&source&data&app_absent&lang=es">WhatsApp</a>
                                <a class="service-btn" href="mailto:diagnostico@sanatorioprivado.com.ar">Email</a>
                            </div>
                        </div>
                        <div class="body__cuerpo-text">
                            <h5 class="body__cuerpo-text-subtitle">Preparaci\xf3n para Estudios</h5>
                            <div class="body__cuerpo-box">
                                <a class="link" href="#">TAC sin contraste</a>
                                <a class="link" href="#">TAC con contraste</a>
                                <a class="link" href="#">TAC Abdomen con contraste</a>
                                <a class="link" href="#">Ecografia Tiroidea / Testicular / Partes Blandas</a>
                                <a class="link" href="#">Eco Doppler Arterial y/o Venoso</a>
                                <a class="link" href="#">Ecografia Ginecologica / Renal / Vesico / Prostatica</a>
                                <a class="link" href="#">Ecografia Intravaginal</a>
                                <a class="link" href="#">Ecografia Obstetricia / Doppler</a>
                                <a class="link" href="#">Ecografia Abdominal / Hepatobiliar y Pancreatica</a>
                                <a class="link" href="#">Ecografia Mamaria</a>
                                <a class="link" href="#">Mamografia</a>
                                <a class="link" href="#">Punci\xf3n Tiroidea guiada por Ec\xf3grafo</a>
                                <a class="link" href="#">Punci\xf3n Biopsia Mamaria</a>
                                <a class="link" href="#">Punci\xf3n Biopsia Partes Blandas</a>
                                <a class="link" href="#">Punci\xf3n Biopsia Hep\xe1tica</a>
                            </div>
                            <div class="body__cuerpo-box">
                                <img src="${$cb5bd9118782b6aa$exports}" class="body__cuerpo-fotos" alt="Diagn\xf3stico por im\xe1genes" loading="lazy">
                                <img src="${$7570f44800539988$exports}" class="body__cuerpo-fotos" alt="Diagn\xf3stico por im\xe1genes" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
        $f9b38f7fd0fbf448$var$style.innerHTML = `
        .diagnostico__cuerpo{
            flex-direction: column;
        }
        `;
        this.appendChild($f9b38f7fd0fbf448$var$style);
    }
}
/* Define */ customElements.define("diagnostico-page", $f9b38f7fd0fbf448$export$95d338a3ea00042b);


/* Variables */ const $6ebd6b6e3cb2ca9e$var$style = document.createElement("style");
var $7f31a047bcc86bca$exports = {};
$7f31a047bcc86bca$exports = new URL("lab1.566ca7a9.webp", import.meta.url).toString();


var $bf603959c69ba37f$exports = {};
$bf603959c69ba37f$exports = new URL("lab2.abacc093.webp", import.meta.url).toString();


class $6ebd6b6e3cb2ca9e$export$95eb76ec9c38cb29 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "laboratorio-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo laboratorio__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">Laboratorio de An\xe1lisis Cl\xednicos y Microbiol\xf3gicos</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">La Direcci\xf3n del Laboratorio tiene como objetivo la calidad, innovaci\xf3n tecnol\xf3gica y la mejora continua, poniendo \xe9nfasis en la satisfacci\xf3n y seguridad de nuestros pacientes y m\xe9dicos; mediante la entrega de resultados confiables y reproducibles, con un tiempo de respuesta adecuado a los compromisos establecidos y de acuerdo al uso previsto para diagn\xf3stico, pron\xf3stico y seguimiento cl\xednico.<br>El plantel del Laboratorio cuenta con destacados profesionales comprometidos con la capacitaci\xf3n continua.<br>En el mes de enero de 2023, el Laboratorio obtuvo su acreditaci\xf3n del programa de evaluaci\xf3n externa de calidad de la fundaci\xf3n bioqu\xedmica argentina.<br>Cumplir con esta evaluaci\xf3n vigente implica que el Laboratorio tiene implementado un sistema de Gesti\xf3n de la Calidad en mejora continua, reconociendo su competencia t\xe9cnica para la realizaci\xf3n de los an\xe1lisis acreditados.<br><br>\u{2022} Direcci\xf3n T\xe9cnica:<br>Dra. Liliana Bertola - M.P. 3.585<br><br>\u{2022} Bioquimicos:<br>Dra. Gisel Bersi - M.P. 6.343<br>Dra. Mar\xeda Julia Armonti - M.P. 4.767<br>Dra. Flavia M\xe1spero - M.P. 6.656<br><br>\u{2022} Tec. Laboratorio:<br>Avila Daniela<br>Emiliozzi Liliana<br>Ortiz Karina</h5>
                            <h5 class="body__cuerpo-text-subtitle">\u{2022} Contacto:</h5>
                            <div class="service-actions">
                                <a class="service-btn" href="/horarios">Horarios</a>
                                <a class="service-btn" href="https://api.whatsapp.com/send?phone=543585610243&text&source&data&app_absent&lang=es">WhatsApp</a>
                                <a class="service-btn" href="mailto:laboratorio@sanatorioprivado.com.ar">Email</a>
                            </div>
                        </div>
                        <div class="body__cuerpo-text">
                            <h5 class="body__cuerpo-text-subtitle">Preparaci\xf3n para Estudios</h5>
                            <div class="body__cuerpo-box">
                                <a class="link" href="#">Curva de Glucosa</a>
                                <a class="link" href="#">Recolecci\xf3n de orina de 24Hs para dosar calciura</a>
                                <a class="link" href="#">Extracci\xf3n de Serotonina</a>
                                <a class="link" href="#">Clearence de Creatinina</a>
                                <a class="link" href="#">Examen Coparasitologico</a>
                                <a class="link" href="#">Cortisol Salival</a>
                                <a class="link" href="#">Extracci\xf3n de Prolactina</a>
                            </div>
                            <div class="body__cuerpo-box">
                                <img src="${$7f31a047bcc86bca$exports}" class="body__cuerpo-fotos" alt="Laboratorio de an\xe1lisis" loading="lazy">
                                <img src="${$bf603959c69ba37f$exports}" class="body__cuerpo-fotos" alt="Laboratorio de an\xe1lisis" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
        $6ebd6b6e3cb2ca9e$var$style.innerHTML = `
        .laboratorio__cuerpo{
            flex-direction: column;
        }
        `;
        this.appendChild($6ebd6b6e3cb2ca9e$var$style);
    }
}
/* Define */ customElements.define("laboratorio-page", $6ebd6b6e3cb2ca9e$export$95eb76ec9c38cb29);


/* Variables */ const $e8ae634224872ffd$var$style = document.createElement("style");
class $e8ae634224872ffd$export$c714c64c99919b65 extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.className = "cardiologia-page";
        this.innerHTML = `
        <div class="page-container">
            <div class="page-body">
                <div class="body-box">
                    <div class="body__cuerpo">
                        <div class="body__cuerpo-text">
                            <br>
                            <h3 class="body__cuerpo-text-title">Servicio de Cardiolog\xeda</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">En Sanatorio Privado R\xedo Cuarto, entendemos la importancia de la salud card\xedaca y nos enorgullece ofrecer un servicio de Cardiolog\xeda de primer nivel con los mejores cardi\xf3logos de la provincia a su disposici\xf3n.<br>Nuestro equipo de Cardiolog\xeda est\xe1 compuesto por destacados profesionales, reconocidos como los mejores en su campo. Su dedicaci\xf3n y experiencia aseguran que cada paciente reciba una atenci\xf3n personalizada y de calidad excepcional.<br>Nos comprometemos a brindar las herramientas necesarias para evaluar su salud card\xedaca de manera completa. Realizamos estudios de vanguardia, incluyendo Ecocardiograma Doppler, Ergometr\xeda, Holter de 24 horas y Presurometr\xeda o Monitoreo Ambulatorio de Presi\xf3n Arterial. Estos estudios son fundamentales para un diagn\xf3stico preciso y un plan de tratamiento efectivo.</h5>

                            <h3 class="body__cuerpo-text-estudio">ECOCARDIOGRAMA DOPPLER</h3>
                            <h5 class="body__cuerpo-text-subtitle">Permite visualizar las cavidades card\xedacas, su tama\xf1o, el movimiento de sus paredes, adem\xe1s de la estructura y el funcionamiento de las v\xe1lvulas.<br><br>\xbfC\xd3MO FUNCIONA?<br>Las im\xe1genes se obtienen apoyando un dispositivo llamado "transductor", en distintos puntos de la pared del t\xf3rax. Se trata de un procedimiento no invasivo y no doloroso.<br><br>RECOMENDACIONES PARA EL PACIENTE<br>\u{2022} No requiere preparaci\xf3n previa ni ayuno.<br>\u{2022} Debe tomar su medicaci\xf3n habitual.</h5>

                            <h3 class="body__cuerpo-text-estudio">ERGOMETR\xcdA (BICICLETA)</h3>
                            <h5 class="body__cuerpo-text-subtitle">Se denomina ergometr\xeda a la prueba diagn\xf3stica que consiste en realizar un registro del electrocardiograma durante un esfuerzo controlado, est\xe1 indicado ante factores de riesgo tales como hipertensi\xf3n, diabetes y referencia de dolor de pecho.<br><br>\xbfC\xd3MO FUNCIONA?<br>Se le colocan unos electrodos adhesivos en el t\xf3rax, se le conecta al equipo y siguiendo las instrucciones debe andar en bicicleta est\xe1tica. Durante el esfuerzo se le registrar\xe1 el electrocardiograma y se le tomar\xe1 la presi\xf3n arterial.<br><br>RECOMENDACIONES PARA EL PACIENTE<br>\u{2022} Ingerir un desayuno liviano previo al estudio.<br>\u{2022} No fumar por lo menos 8 horas antes del estudio.<br>\u{2022} Evitar la ingesta de bebidas alcoh\xf3licas, cafe\xedna y otras excitantes horas antes a la realizaci\xf3n de la prueba.<br>\u{2022} Vaya equipado con ropa holgada y c\xf3moda, y calzado apropiado para andar o correr.<br><br>Preparaci\xf3n:<br>\u{2022} Traer 10 Electrodos.<br>\u{2022} Llegar puntual a su turno.<br>\u{2022} Desayunar liviano (sin excepci\xf3n).<br>\u{2022} Tomar la medicaci\xf3n habitual.<br>\u{2022} Utilizar ropa c\xf3moda y calzado adecuado para realizar ejercicio f\xedsico.</h5>

                            <h3 class="body__cuerpo-text-estudio">HOLTER DE 24 HORAS</h3>
                            <h5 class="body__cuerpo-text-subtitle">Consiste en la monitorizaci\xf3n ambulatoria del electrocardiograma por un periodo de 24 a 48 horas, durante la actividad diaria habitual del paciente. Se usa en pacientes con sospecha de arritmia card\xedaca.<br><br>\xbfC\xd3MO FUNCIONA?<br>El monitor tiene entre 6 y 10 cables. Las derivaciones van conectados a electrodos, los cuales se colocan en el pecho, estos se conectan a un Holter del tama\xf1o de un tel\xe9fono m\xf3vil que graba los impulsos el\xe9ctricos del coraz\xf3n durante 24 horas.<br><br>RECOMENDACI\xd3N PARA EL PACIENTE<br>\u{2022} No se necesita estar en ayunas. Puede ingerir alimentos.<br>\u{2022} El/La paciente debe venir ba\xf1ado antes de colocarse el equipo porque durante el monitoreo no se puede ba\xf1ar, hasta ser retirado.<br>\u{2022} No debe untarse cremas, talcos, aceites, colonias, ya que se puede da\xf1ar el equipo.<br>\u{2022} No es necesario suspender los medicamentos si toma algunos.<br><br>Preparaci\xf3n:<br>El paciente recibir\xe1 un equipo que deber\xe1 devolver luego de siete d\xedas h\xe1biles.<br>\u{2022} Traer 8 Electrodos y 1 Pila "AA".</h5>

                            <h3 class="body__cuerpo-text-estudio">PRESUROMETR\xcdA O MONITOREO AMBULATORIO DE PRESI\xd3N ARTERIAL</h3>
                            <h5 class="body__cuerpo-text-subtitle">La presurometr\xeda es un estudio indicado para el monitoreo de la presi\xf3n arterial durante 24 hs. Se indica en pacientes con sospecha de hipertensi\xf3n y en pacientes hipertensos para valoraci\xf3n de la respuesta al tratamiento.<br><br>\xbfC\xd3MO FUNCIONA?<br>El presur\xf3metro se compone de un manguito de insuflaci\xf3n que se coloca en el brazo del paciente, una manguera con una v\xe1lvula y un aparato de mediciones que se lleva colgado en un cintur\xf3n, las mediciones son en forma autom\xe1tica cada 30 a 60 minutos de acuerdo a programaci\xf3n.<br><br>RECOMENDACIONES PARA EL PACIENTE<br>\u{2022} No se requiere preparaci\xf3n previa ni estar en ayunas.<br>\u{2022} Durante el estudio el paciente no se puede ba\xf1ar.<br>\u{2022} Cuando el presur\xf3metro est\xe9 realizando la medici\xf3n el paciente debe mantener el brazo relajado y estirado hasta que la misma se complete.<br><br>Preparaci\xf3n:<br>\u{2022} Traer 2 Pilas "AA".</h5>

                            <br>
                            <h3 class="body__cuerpo-text-title">Servicio de Hemodinamia</h3>
                            <br>
                            <h5 class="body__cuerpo-text-subtitle">Adem\xe1s de nuestros estudios cardiol\xf3gicos, contamos con el servicio de Hemodinamia, una herramienta invaluable para evaluar y tratar diversas afecciones card\xedacas. Nuestro compromiso es poner la \xfaltima tecnolog\xeda m\xe9dica a disposici\xf3n y mejorar la calidad de vida de nuestros pacientes, especialmente aquellos que son adultos mayores. Reconocemos la importancia de brindar un cuidado especializado a esta poblaci\xf3n, ya que a menudo enfrentan problemas de salud relacionados con el sistema cardiovascular.<br>En nuestras modernas instalaciones, utilizamos tecnolog\xeda de vanguardia para llevar a cabo procedimientos de hemodinamia. Esto nos permite diagnosticar y tratar de manera efectiva una amplia gama de enfermedades cardiovasculares, como enfermedad coronaria, insuficiencia card\xedaca y enfermedad de las arterias perif\xe9ricas.</h5>

                            <br>
                            <h5 class="body__cuerpo-text-subtitle">\u{2022} Contacto:</h5>
                            <div class="service-actions">
                                <a class="service-btn" href="/horarios">Horarios</a>
                                <a class="service-btn" href="https://api.whatsapp.com/send?phone=543585610243&text&source&data&app_absent&lang=es">WhatsApp</a>
                                <a class="service-btn" href="mailto:cardiologia@sanatorioprivado.com.ar">Email</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
        $e8ae634224872ffd$var$style.innerHTML = `
        .body__cuerpo-text-estudio{
            font-size: 20px;
            margin: 15px auto 5px auto;
        }
        `;
        this.appendChild($e8ae634224872ffd$var$style);
    }
}
/* Define */ customElements.define("cardiologia-page", $e8ae634224872ffd$export$c714c64c99919b65);


/* Imports */ 
/* Variables */ const $e817d3341cf3ea9c$var$router = new (0, $f9d9d110dea7aeee$export$55185c17a0fcbe46)(document.querySelector(".root"));
/* Function */ $e817d3341cf3ea9c$var$router.setRoutes([
    {
        path: "/",
        component: "welcome-page"
    },
    {
        path: "/nosotros",
        component: "nosotros-page"
    },
    {
        path: "/trabaja",
        component: "trabaja-page"
    },
    {
        path: "/cobertura",
        component: "cobertura-page"
    },
    {
        path: "/horarios",
        component: "horarios-page"
    },
    {
        path: "/profesionales",
        component: "no-page"
    },
    {
        path: "/diagnostico",
        component: "diagnostico-page"
    },
    {
        path: "/laboratorio",
        component: "laboratorio-page"
    },
    {
        path: "/cardiologia",
        component: "cardiologia-page"
    },
    {
        path: "/sedes",
        component: "sedes-page"
    }
]);




//# sourceMappingURL=index.b33cf785.js.map
